import React from "react";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import moment from "moment";
import { FormLabel } from "react-bootstrap";
import CommonIcon from "../../helpers/icons";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  Backdrop,
  CircularProgress,
  Divider,
  FormControlLabel,
  FormControl,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import toggleMenu from "../../../redux/SideBar/sideBarActions";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Avatar,
  Autocomplete,
  Paper,
  responsiveFontSizes,
} from "@mui/material";
import $, { data } from "jquery";
import { Add, Email } from "@mui/icons-material";
import ApplicationListViewTable from "../../custom/ApplicatoinListView";
import { Button } from "react-bootstrap";
import RoleListViewTable from "../../custom/RoleListView";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import IconButton from "@mui/material/IconButton";
import Actions from "../../../action/api";
import API from "../../helpers/endpointservice";
import {
  deleteMappedUser,
  getApplicationLicenseStatus,
  auditLog,
  getApplicationUsers,
  licensePurchase,
  userRoleAssign,
  userRemoveTable,
  unAssignedUsers,
  roleBasedUsers,
  validationCheck,
  getApplication,
  allApplication,
  mapUser,
  purchaseLicense,
  Unsubscribe,
  Subscribe,
  Trial,
  GetDetails,
  TryOrBuyProducts,
} from "../../../action/ApplicationApi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import subscription from "../Subscription/subscription";

class Application extends React.Component {
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.state = {
      rolebasedId: "",
      trailstart: false,
      buystart: false,
      trialCount: 0,

      assignedLicenses: 0,
      apprefernceid: 0,
      applicationroles: [],
      unAssignedUsers: [],
      applicationId: 0,
      applicationname: "",
      isAllowToRemoveLicense: true,
      totalLicense: 0,
      subscriptionStatus: "",
      isFilterApplied: false,
      availableLicense: 0,
      checkedUser: false,
      selectedEmails: [],
      rolebasedtableuser: [],
      selectedUserEmails: [],
      editTable: false,
      invalidLicense: false,
      mockTotallicense: 0,
      subscriptionTable: false,
      unsubscriptionTable: false,
      choosedProduct: "",
      clientId: "",
      applicationname: "",
      subcriptionStatus: "",
      opendialogun: false,
      subscribestartdate: "",
      trialstartDate: "",
      radiovalue: "",
      applicationIdNavigate: "",
      buyproduct: false,
      trialproduct: false,
      productsDetails: [],
      filterProductDropdown: [],

      editLicense: false,
      buyLicense: false,
      expiryDate: "",
      admins: [
        { name: "Test User 2", email: "test.user2@qantler.sg" },
        { name: "TRV FSP", email: "test@qantler.com" },
        { name: "AISHAH BTE ZAINOL ABDEEN", email: "test@qantler.com" },
      ],
      selectedUserss: null,
      users: [
        { name: "AAAAA", email: "aaa@gmail.com" },
        { name: "AAAA display", email: "aaaadisplay@qantler.com" },
        { name: "AAA display", email: "aaadisplay@gmail.com" },
        { name: "A_AB_1", email: "abdul@qantler.sg" },
        { name: "#_AB_2", email: "test@qantler.com" },
        { name: "#_AB_3", email: "test@qantler.com" },
        { name: "Global Admin", email: "global.admin@qantler.sg" },
        // Add more users as needed
      ],
      columnHeaders: [
        { key: "name", label: "Product", width: "20%" },
        { key: "purchasedQuantity", label: "Purchase Quantity", width: "10%" },
        { key: "assignedLicense", label: "Assigned Licenses", width: "10%" },
        {
          key: "subcriptionStatus",
          label: "Subscription Status",
          width: "15%",
        },
        { key: "expiryDate", label: "Expiry Date", width: "15%" },
        { key: "purchaseDate", label: "Purchase Date", width: "15%" },
        { key: "Action", label: "Action", width: "20%" },
      ],

      columnHeaderunSubscibed: [
        { key: "name", label: "Product", width: "20%" },
        { key: "action", label: "Action", width: "50%" },
      ],

      logs: [],
      groupedData: {},
      normalData: [],
      roleColumnHeaders: [
        { key: "checkbox", label: "", width: "5%" },
        { key: "name", label: "Name", width: "20%" },
        { key: "email", label: "Email", width: "10%" },
      ],
      view: false,
      viewUser: [],
      choice: {
        application: [],
        subscriptionStatus: "",
        purchasedDate: "",
      },
      filteredOptions: {
        application: [],
        subscriptionStatus: "",
        purchasedDate: "",
      },
      licenseQuantity: 0,
      selectedItem: null,
      isAddingResource: false,
      selectedRoleId: null,
      isEditing: false,
      filters: {
        limit: 15,
        offset: 0,
        sortBy: "application",
        sortByOrder: "asc",
        application: [],
        subscriptionStatus: "",
        expiryDate: null,
        pageNumber: 1,
        PageSize: 1,
      },
      roleFilters: {
        sortBy: "name",
        sortByOrder: "asc",
      },
      isloading: false,
      backdrop: false,
      editUserId: null,
      selectedUsers: [],
      selectedUser: null,
      groupedColumn: null,
      collapsedGroups: {},
      filtered: {},
      isMobile: false,
      isMobile600: false,
      isMobile380: false,
      height: window.innerHeight,
      selectedPlanId: "",
    };
    this.handleAddClick = this.handleAddClick.bind(this);
    this.handleRoleClick = this.handleRoleClick.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
  }

  // handleUserChange = (event, newValue) => {
  //   this.setState({ selectedUser: newValue });
  // };

  customToast = (message) => {
    toast(message, {
      hideProgressBar: true,
      autoClose: 4000, // Customize time as per your requirement
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      position: "top-right",
      className: "custom-toast", // Add a custom class here
    });
  };
  handleAddAdmin = () => {
    const { selectedUser, admins } = this.state;
    if (selectedUser) {
      this.setState({
        admins: [...admins, selectedUser],
        selectedUser: null,
      });
    }
  };

  getTrialCount = () => {
    Actions.GET(API.TrialCount)
      .then((res) => {
        if (res.data) {
          this.setState({ trialCount: res.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  componentDidMount() {
    let data = {
      sortBy: this.state.filters.sortBy,
      sortByOrder: this.state.filters.sortByOrder,
      pageNumber: this.state.filters.pageNumber,
      pageSize: this.state.filters.PageSize,
      application: this.state.filters.application,
      subscriptionStatus: this.state.filters.subscriptionStatus,
    };
    this.setState({
      filtered: data,
    });
    this.getAllApplicationFilterData();
    let tableLoader = false;
    this.getTrialCount();
    this.getAllApplicationData(data);
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
  }

  componentDidUpdate = () => {
    // console.log(this.props.getApplication);
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.getApplication) {
      console.log(nextProps.getApplication);
    }
    if (nextProps.getApplicationLicenseStatus) {
      const normalData = prevState.normalData || [];
      const applicationId = nextProps.getApplicationLicenseStatus.applicationId;
      const applicationData = normalData.find(
        (app) => app.applicationId === applicationId
      );
      const isPurchased = applicationData ? applicationData.isPurchased : false;
      console.log(isPurchased);
      const updatedState = {
        view: true,
        viewUser: nextProps.getApplicationLicenseStatus,
        isloading: false,
        editUserId: nextProps.getApplicationLicenseStatus.applicationId,
        selectedItem: {
          applicationId: nextProps.getApplicationLicenseStatus.applicationId,
          applicationName:
            nextProps.getApplicationLicenseStatus.applicationName,
          subscriptionStatus: nextProps.getApplicationLicenseStatus.statusName,
          applicationUrl: nextProps.getApplicationLicenseStatus.applicationUrl,
          applicationDesc:
            nextProps.getApplicationLicenseStatus.applicationDesc,
          billingFrequency:
            nextProps.getApplicationLicenseStatus.billingFrequency,
          availableLicenses:
            nextProps.getApplicationLicenseStatus.availableLicenses,
          assignedLicenses:
            nextProps.getApplicationLicenseStatus.assignedLicenses,
          purchasedDate: nextProps.getApplicationLicenseStatus.purchasedDate,
          roles: nextProps.getApplicationLicenseStatus.roles,
          isPurchased: isPurchased,
        },
      };

      // Set default selected role if there are roles present
      if (
        nextProps.getApplicationLicenseStatus.roles &&
        nextProps.getApplicationLicenseStatus.roles.length > 0
      ) {
        updatedState.selectedRoleId =
          nextProps.getApplicationLicenseStatus.roles[0].roleId;
      }

      nextProps.dispatch({
        type: "APPLICATION_LICENSE_LOADED_SUCCESS",
        data: null,
      });

      return updatedState;
    }

    return null;
  }

  getAllApplicationData = (data, tableLoader, resetTableOrder = false) => {
    tableLoader
      ? this.setState({ isLoader: true })
      : this.setState({ isloading: true });
    this.props
      .dispatch(allApplication(data))
      .then((response) => {
        console.log(response.data);
        this.processData(response.data, tableLoader, resetTableOrder);
      })
      .catch((error) => {
        console.log(error);
        this.setState({ isloading: false });
      });
  };

  getAllApplicationFilterData = () => {
    this.props
      .dispatch(allApplication({}))
      .then((response) => {
        console.log(response.data);
        this.setState({ filterProductDropdown: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  processData = (result, tableLoader, resetTableOrder) => {
    const normalData = !resetTableOrder ? this.state.normalData || [] : [];
    const newData = [];
    console.log(result);

    if (Array.isArray(result)) {
      result.forEach((value) => {
        const applicationData = {
          ...value,
          purchasedDate: value.purchasedDate
            ? moment(value.purchasedDate).format("DD MMM YYYY")
            : "-",
        };

        // if (!normalData.some(x => x.applicationId === applicationData.applicationId)) {
        normalData.push(applicationData);
        // }
        newData.push(applicationData);
      });
    }
    console.log(normalData);
    const isValue = newData.length >= 10 ? false : true;
    this.setState({
      normalData: normalData,
      isLoader: false,
      isloading: false,
      isScroll: isValue,
    });
  };

  resize = () => {
    if (window.innerWidth < 700) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
        isWebMobile: false,
      });
    }

    if (window.innerWidth < 468) {
      this.setState({
        isMobile600: true,
        isWebMobile: true,
      });
    } else {
      this.setState({
        isMobile600: false,
        isWebMobile: false,
      });
    }

    if (window.innerWidth < 380) {
      this.setState({
        isMobile380: true,
      });
      this.setState({
        isMobile380: true,
      });
    } else {
      this.setState({
        isMobile380: false,
      });
    }
    this.setState({
      height: window.innerHeight,
    });
  };

  toggleWebFilter = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("FilterScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");
    this.setState({});
  };

  closeWebFilter = () => {
    $("#FilterScreen").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    this.setState({ rows: [] });
    this.setState({
      choice: {
        application: [],
        subscriptionStatus: "",
        purchasedDate: "",
      },
    });
  };
  closeWebFilter1 = () => {
    $("#FilterScreen").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    this.setState({ rows: [] });
  };

  clearFilter = () => {
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          application: [],
          subscriptionStatus: 0,
          purchasedDate: null,
        },
        filteredOptions: {
          ...prevState.filteredOptions,
          application: [],
          subscriptionStatus: 0,
          purchasedDate: null,
        },
        choice: {
          ...prevState.choice,
          application: [],
          subscriptionStatus: 0,
          purchasedDate: null,
        },
        normalData: [],
        groupedData: {},
        groupedColumn: null,
        filtered: {
          sortBy: prevState.filters.sortBy.toLowerCase(),
          sortByOrder: prevState.filters.sortByOrder,
          limit: 15,
          offset: 0,
          application: [],
          subscriptionStatus: 0,
          purchasedDate: null,
        },
        isGroupBy: true,
      }),
      () => {
        const data = {
          sortBy: this.state.filters.sortBy.toLowerCase(),
          sortByOrder: this.state.filters.sortByOrder,
          limit: 15,
          offset: 0,
          application: this.state.filters.application,
          subscriptionStatus: this.state.filters.subscriptionStatus,
          purchasedDate: this.state.filters.purchasedDate,
        };

        this.getAllApplicationData(data, true);
        this.setState({ isFilterApplied: false });
        this.closeWebFilter();
      }
    );
  };

  viewuser = (event) => {
    const userId = event.target.id;
    this.setState({
      view: true,
    });
    this.setState({ actionId: userId }, () => {
      this.props.dispatch(getApplicationLicenseStatus(userId));

      this.newFormShow();
    });
  };

  newFormShow = () => {
    const offcanvasElement = document.getElementById("productsViewScreen");

    // Check if the Offcanvas element exists and has the 'show' class
    if (offcanvasElement && offcanvasElement.classList.contains("show")) {
      console.log("Offcanvas is already open.");
      return; // Exit the function if Offcanvas is already open
    }

    // If the Offcanvas is not open, create a new instance and show it
    let myOffcanvas = new window.bootstrap.Offcanvas(offcanvasElement);
    myOffcanvas.show();

    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");

    this.setState({
      backdrop: true,
    });
  };
  newTrialFormShow = () => {
    const offcanvasElement = document.getElementById("trialscreen");

    // Check if the Offcanvas element exists and has the 'show' class
    if (offcanvasElement && offcanvasElement.classList.contains("show")) {
      console.log("Offcanvas is already open.");
      return; // Exit the function if Offcanvas is already open
    }

    // If the Offcanvas is not open, create a new instance and show it
    let myOffcanvas = new window.bootstrap.Offcanvas(offcanvasElement);
    myOffcanvas.show();

    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");

    this.setState({
      backdrop: true,
    });
  };
  TrialFormShow = () => {
    const offcanvasElement = document.getElementById("newtrialscreen");

    // Check if the Offcanvas element exists and has the 'show' class
    if (offcanvasElement && offcanvasElement.classList.contains("show")) {
      console.log("Offcanvas is already open.");
      return; // Exit the function if Offcanvas is already open
    }

    // If the Offcanvas is not open, create a new instance and show it
    let myOffcanvas = new window.bootstrap.Offcanvas(offcanvasElement);
    myOffcanvas.show();

    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");

    this.setState({
      backdrop: true,
    });
  };
  newBuyFormShow = () => {
    const offcanvasElement = document.getElementById("buyscreen");

    // Check if the Offcanvas element exists and has the 'show' class
    if (offcanvasElement && offcanvasElement.classList.contains("show")) {
      console.log("Offcanvas is already open.");
      return;
    }

    let myOffcanvas = new window.bootstrap.Offcanvas(offcanvasElement);
    myOffcanvas.show();

    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");

    this.setState({
      backdrop: true,
    });
  };
  newOrderPlaceFormShow = () => {
    const offcanvasElement = document.getElementById("orderplacescreen");

    // Check if the Offcanvas element exists and has the 'show' class
    if (offcanvasElement && offcanvasElement.classList.contains("show")) {
      console.log("Offcanvas is already open.");
      return; // Exit the function if Offcanvas is already open
    }

    // If the Offcanvas is not open, create a new instance and show it
    let myOffcanvas = new window.bootstrap.Offcanvas(offcanvasElement);
    myOffcanvas.show();

    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");

    this.setState({
      backdrop: true,
    });
  };

  //   let myOffcanvas = new window.bootstrap.Offcanvas(
  //     document.getElementById("AddForm1unsubscribe")
  //   );
  //   myOffcanvas.show();
  //   $("body").addClass("scrollhide");
  //   $(".main-content").addClass("scrollhide");
  //   this.setState({
  //     backdrop: true,
  //   });
  // };

  // closeunsubscribeForm = () => {
  //   $("#AddForm1unsubscribe").removeClass("show");
  //   $(".offcanvas-backdrop").removeClass("show");
  //   $("body").removeClass("scrollhide");
  //   $(".main-content").removeClass("scrollhide");
  //   let data = {

  //     sortBy: this.state.filters.sortBy,
  //     sortByOrder: this.state.filters.sortByOrder,
  //     pageNumber: this.state.filters.pageNumber,
  //     pageSize: this.state.filters.PageSize,
  //     application: this.state.filters.application,
  //     subscriptionStatus: this.state.filters.subscriptionStatus,

  //   }
  //   this.getAllApplicationData(data, false, true)
  //   this.setState({
  //     selectedItem: {
  //       availableLicenses: 0,
  //     },
  //     backdrop: false,
  //     isAddingResource: false,
  //     selectedRoleId: null,
  //     isEditing: false,
  //   });
  // };

  closeForm = () => {
    $("#productsViewScreen").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    let data = {
      sortBy: this.state.filters.sortBy,
      sortByOrder: this.state.filters.sortByOrder,
      pageNumber: this.state.filters.pageNumber,
      pageSize: this.state.filters.PageSize,
      application: this.state.filters.application,
      subscriptionStatus: this.state.filters.subscriptionStatus,
    };
    // this.getAllApplicationData(data, false, true)
    this.setState({
      selectedItem: {
        availableLicenses: 0,
      },
      backdrop: false,
      isAddingResource: false,
      selectedRoleId: null,
      isEditing: false,
    });
  };

  closeFormlic = () => {
    $("#Licenseform").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    this.setState({
      selectedItem: {
        availableLicenses: 0,
      },
      backdrop: false,
      isAddingResource: false,
      selectedRoleId: null,
      isEditing: false,
    });
  };
  closeFormorderPlaced = () => {
    $("#newtrialscreen").removeClass("show");
    $("#orderplacescreen").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    this.setState({
      selectedItem: {
        availableLicenses: 0,
      },
      backdrop: false,
      isAddingResource: false,
      selectedRoleId: null,
      isEditing: false,
    });
  };

  getApplication = async () => {
    this.props
      .dispatch(validationCheck(this.state.apprefernceid))
      .then(async (response) => {
        console.log(response.data);
        this.setState({
          totalLicense: response.data.totalLicenses,
          availableLicense: response.data.availableLicenses,
          assignedLicenses: response.data.assingedLicenses,
          mockTotallicense: response.data.totalLicenses,
          // subcriptionStatus:response.data.
        });
      });
    let data = {
      sortBy: this.state.filters.sortBy,
      sortByOrder: this.state.filters.sortByOrder,
      pageNumber: this.state.filters.pageNumber,
      pageSize: this.state.filters.PageSize,
      application: this.state.filters.application,
      subscriptionStatus: this.state.filters.subscriptionStatus,
    };
    this.setState({ normalData: [] });
    this.getAllApplicationData(data);
  };

  handleEditId = (
    applicationId,
    clientId,
    status,
    expiryDate,
    trialstartDate,
    subscribestartdate
  ) => {
    console.log(applicationId, clientId, status);

    this.setState(
      {
        apprefernceid: applicationId,
        clientId: clientId,
        view: true,
        actionId: applicationId,
        editTable: false,
        editLicense: false,
        subcriptionStatus: status,
        expiryDate: expiryDate ? expiryDate : "",
        trialstartDate: trialstartDate ? trialstartDate : "",
        subscribestartdate: subscribestartdate ? subscribestartdate : "",
      },
      async () => {
        await this.props
          .dispatch(getApplication(applicationId))
          .then(async (response) => {
            console.log(response.data);
            this.setState({
              totalLicense: response.data.license.totalLicenses,
              availableLicense: response.data.license.availableLicenses,
              applicationname: response.data?.name,
              // subcriptionStatus: response.data.subcriptionStatus,
              applicationId: response.data.applicationId,
              applicationroles: response.data.roles,
              assignedLicenses: response.data.license.assingedLicenses,
              mockTotallicense: response.data.license.totalLicenses,
              subscriptionStatus: response.data.purchaseInfo.subscriptionStatus,
            });
            this.newFormShow();
            // this.props.dispatch(roleBasedUsers(applicationId, response.data.roles[0].id)).then((res) => {
            //   console.log(res);
            //   this.setState({ rolebasedtableuser: res.data })
            //   this.setState({
            //     rolebasedId: response.data.roles[0].id,
            //     value: response.data.roles[0].id
            //   })
            // })

            // this.props.dispatch(auditLog(this.state.apprefernceid)).then((res) => {
            //   console.log(res.data, 'Audit Log');
            //   this.setState({ logs: res.data })
            // })

            // this.props.dispatch(unAssignedUsers(applicationId)).then((res) => {
            //   console.log(res.data);
            //   this.setState({
            //     unAssignedUsers: res.data
            //   })
            // })
          });
        // await this.props.dispatch(getApplicationLicenseStatus(applicationId,this.state.filters.sortBy,this.state.filters.sortByOrder));
      }
    );
  };

  handleunsubscribe = (values, clientId, status) => {
    console.log(clientId);
    this.setState({
      applicationname: values,
      clientId: clientId,
      subcriptionStatus: status,
    });
    this.newFormShow();
  };

  lookupChange = (e, selectedValue, title) => {
    if (title === "application") {
      this.setState({
        choice: { ...this.state.choice, application: selectedValue },
      });
    }

    if (title === "subscriptionStatus") {
      if (selectedValue !== null) {
        this.setState({
          choice: {
            ...this.state.choice,
            subscriptionStatus: selectedValue.status,
          },
        });
      } else {
        this.setState({
          choice: { ...this.state.choice, subscriptionStatus: null },
        });
      }
    }
    if (title === "purchasedDate") {
      const formattedDate = e.target.value
        ? new Date(e.target.value).toISOString()
        : "";
      console.log(formattedDate);
      this.setState({
        choice: { ...this.state.choice, purchasedDate: e.target.value },
      });
    }
  };

  cancel = () => {
    this.setState({
      opendialog: true,
      successText: "Changes are not saved yet. Are you sure you want to close?",
    });
  };

  noAction = () => {
    this.setState({
      opendialog: false,
    });
  };

  yesAction = () => {
    this.props.this.setState({
      opendialog: false,
    });
  };

  getStatusClass(status) {
    if (typeof status === "string") {
      switch (status.toLowerCase()) {
        case "expired":
          return "expired";
        case "active":
          return "active";
        case "inactive":
          return "inactive";
        default:
          return "";
      }
    } else {
      return "";
    }
  }

  handleAddClick() {
    this.setState({ isAddingResource: true });
  }

  handleEditClick = () => {
    this.setState({ isEditing: true });
  };

  handlePurchaseClick = () => {
    this.setState({ isEditing: false });
  };

  toggleEdit() {
    this.setState((prevState) => ({ isEditing: !prevState.isEditing }));
  }

  handleRoleClick(roleId) {
    const { selectedRoleId } = this.state;
    if (selectedRoleId === roleId) {
      this.setState({ selectedRoleId: null });
    } else {
      this.setState({ selectedRoleId: roleId });
    }
  }

  handleIncrement = () => {
    // this.setState((prevState) => ({
    //   totalLicense: this.state.totalLicense + 1,
    //   invalidLicense:false,
    // }));
    this.setState((prevState) => ({
      mockTotallicense: this.state.mockTotallicense + 1,
      invalidLicense: false,
    }));
  };

  handleDecrement = () => {
    console.log(
      typeof this.state.assignedLicenses,
      typeof this.state.totalLicense
    );
    if (this.state.assignedLicenses < this.state.mockTotallicense) {
      this.setState((prevState) => ({
        mockTotallicense: Math.max(0, this.state.mockTotallicense - 1),
      }));
    } else {
      this.customToast("Remove users and then decrease the count");
      this.setState({ invalidLicense: true });
    }
  };

  handleChange = (e) => {
    const value = e.target.value;
    // Allow only numbers and prevent any other characters
    if (/^\d*$/.test(value)) {
      this.setState((prevState) => ({
        licenseQuantity: Number(value),
      }));
    }
  };

  handlePurchase = () => {
    const { selectedItem } = this.state;
    const data = {
      applicationId: selectedItem.applicationId,
      purchasedLicense: selectedItem.availableLicenses,
    };

    return new Promise((resolve, reject) => {
      this.props
        .dispatch(purchaseLicense(data))
        .then((response) => {
          console.log("Purchase successful:", response);

          let data = {
            sortBy: this.state.filters.sortBy,
            sortByOrder: this.state.filters.sortByOrder,
            limit: this.state.filters.limit,
            offset: this.state.filters.offset,
          };
          this.setState({
            filtered: data,
          });
          let tableLoader = false;
          return this.getAllApplicationData(data, tableLoader, true);
        })
        .then(() => {
          this.closeForm();
          resolve();
        })
        .catch((error) => {
          console.error("Purchase failed:", error);
          reject(error);
        });
    });
  };

  isUserSelected = (roleId, userId) => {
    return this.state.selectedUsers.some(
      (user) => user.roleId === roleId && user.userId === userId
    );
  };

  // handleDelete = () => {
  //   const { selectedUsers, selectedItem } = this.state;
  //   const userIds = selectedUsers.map(user => user.userId);
  //   const roleId = selectedUsers[0]?.roleId; // Assuming roleId is consistent for selectedUsers
  //   const applicationId = selectedItem.applicationId;
  //   const applicationRoleId = selectedItem.roles.find(role => role.roleId === roleId)?.applicationRoleId; // Handle if roleId isn't found

  //   if (!roleId || !applicationRoleId) {
  //     console.error("Role ID or Application Role ID not found.");
  //     return;
  //   }

  //   this.setState({ isloading: true }); // Start loader

  //   const requestBody = {
  //     roleId,
  //     userId: userIds,
  //     applicationId,
  //     applicationRoleId,
  //   };

  //   // Clear selectedUsers immediately to prevent unintended selection
  //   this.setState({ selectedUsers: [] });

  //   return new Promise((resolve, reject) => {
  //     this.props.dispatch(deleteMappedUser(requestBody))
  //       .then(response => {
  //         console.log("Delete successful:", response);
  //         // Update state after successful deletion
  //         this.setState(prevState => {
  //           const updatedRoles = prevState.selectedItem.roles.map(role => {
  //             if (role.roleId === roleId) {
  //               return {
  //                 ...role,
  //                 users: role.users.filter(user => !userIds.includes(user.id)),
  //               };
  //             }
  //             return role;
  //           });
  //           return {
  //             selectedItem: {
  //               ...prevState.selectedItem,
  //               roles: updatedRoles,
  //             },
  //           };
  //         });

  //         // Call getApplicationLicenseStatus and manage loader state
  //         this.props.dispatch(getApplicationLicenseStatus(applicationId))
  //           .then(() => {
  //             console.log("getApplicationLicenseStatus successful");
  //             this.setState({ isloading: false }); // Stop loader after API call completes
  //             resolve();
  //           })
  //           .catch(error => {
  //             console.error("Failed to fetch application status:", error);
  //             this.setState({ isloading: false }); // Stop loader on error
  //             reject(error);
  //           });
  //       })
  //       .catch(error => {
  //         console.error("Delete failed:", error);
  //         this.setState({ isloading: false }); // Stop loader on error
  //         reject(error);
  //       });
  //   });
  // };

  applyFilter = () => {
    const { choice, filters } = this.state;

    // Convert purchasedDate to ISO format if it's not empty
    const purchasedDate = choice.purchasedDate
      ? new Date(choice.purchasedDate).toISOString()
      : null;

    const data = {
      sortBy: filters.sortBy.toLowerCase(),
      sortByOrder: filters.sortByOrder,
      limit: 15,
      offset: 0,
      application: choice.application,
      subscriptionStatus: choice.subscriptionStatus,
      purchasedDate: purchasedDate,
    };
    const shouldFilter =
      (Array.isArray(data.application) && data.application.length > 0) ||
      (data.subscriptionStatus && data.subscriptionStatus.trim() !== "") ||
      purchasedDate !== null;

    console.log(data, shouldFilter);
    if (shouldFilter) {
      this.setState(
        (prevState) => ({
          filters: {
            ...prevState.filters,
            application: choice.application,
            subscriptionStatus: choice.subscriptionStatus,
            purchasedDate: choice.purchasedDate,
          },
          filteredOptions: {
            ...prevState.filteredOptions,
            application: choice.application,
            subscriptionStatus: choice.subscriptionStatus,
            purchasedDate: choice.purchasedDate,
          },
          normalData: [],
          groupedData: {},
          groupedColumn: null,
          filtered: data,
          isGroupBy: true,
          tableLoader: true,
        }),
        () => {
          this.getAllApplicationData(data);
          if (
            choice.application.length !== 0 ||
            choice.subscriptionStatus !== "" ||
            choice.purchasedDate !== ""
          ) {
            this.setState({ isFilterApplied: true });
          } else {
            this.setState({ isFilterApplied: false });
          }
          this.closeWebFilter1();
        }
      );
    }
    else{
      this.customToast("Please provide at least one filter value")
    }
  };
  applyFilterWoCOnditions = () => {
    const { choice, filters } = this.state;

    // Convert purchasedDate to ISO format if it's not empty
    const purchasedDate = choice.purchasedDate
      ? new Date(choice.purchasedDate).toISOString()
      : null;

    const data = {
      sortBy: filters.sortBy.toLowerCase(),
      sortByOrder: filters.sortByOrder,
      limit: 15,
      offset: 0,
      application: choice.application,
      subscriptionStatus: choice.subscriptionStatus,
      purchasedDate: purchasedDate,
    };
      this.setState(
        (prevState) => ({
          filters: {
            ...prevState.filters,
            application: choice.application,
            subscriptionStatus: choice.subscriptionStatus,
            purchasedDate: choice.purchasedDate,
          },
          filteredOptions: {
            ...prevState.filteredOptions,
            application: choice.application,
            subscriptionStatus: choice.subscriptionStatus,
            purchasedDate: choice.purchasedDate,
          },
          normalData: [],
          groupedData: {},
          groupedColumn: null,
          filtered: data,
          isGroupBy: true,
          tableLoader: true,
        }),
        () => {
          this.getAllApplicationData(data);
          if (
            choice.application.length !== 0 ||
            choice.subscriptionStatus !== "" ||
            choice.purchasedDate !== ""
          ) {
            this.setState({ isFilterApplied: true });
          } else {
            this.setState({ isFilterApplied: false });
          }
          this.closeWebFilter1();
        }
      );
    
  };

  applyFilterProducts = (id) => {
    const filtered = this.state.choice.application.filter(
      (item) => item.applicationId !== id
    );

    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          application: filtered,
        },
        filteredOptions: {
          ...prevState.filteredOptions,
          application: filtered,
        },
        choice: {
          ...prevState.choice,
          application: filtered,
        },
        normalData: [],
        groupedData: {},
        groupedColumn: null,
        isGroupBy: true,
        tableLoader: true,
      }),
      () => {
        this.applyFilterWoCOnditions();
      }
    );
  };
  applyFilterStatus = () => {
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          subscriptionStatus: "",
        },
        filteredOptions: {
          ...prevState.filteredOptions,
          subscriptionStatus: "",
        },
        choice: {
          ...prevState.choice,
          subscriptionStatus: "",
        },
        normalData: [],
        groupedData: {},
        groupedColumn: null,
        isGroupBy: true,
        tableLoader: true,
      }),
      () => {
        this.applyFilterWoCOnditions();
      }
    );
  };
  applyFilterDate = () => {
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          purchasedDate: "",
        },
        filteredOptions: {
          ...prevState.filteredOptions,
          purchasedDate: "",
        },
        choice: {
          ...prevState.choice,
          purchasedDate: "",
        },
        normalData: [],
        groupedData: {},
        groupedColumn: null,
        isGroupBy: true,
        tableLoader: true,
      }),
      () => {
        this.applyFilterWoCOnditions();
      }
    );
  };

  handleScroll = () => {
    if (!this.state.isScroll) {
      this.setState(
        (prevState) => ({
          ...prevState,
          isLoader: true,
          filtered: {
            ...prevState.filtered,
            offset: prevState.filtered.offset + 10,
          },
        }),
        () => {
          let tableLoader = true;
          this.getAllApplicationData(this.state.filtered, tableLoader);
        }
      );
    }
  };

  handleSort = (column) => {
    let { filters } = this.state;
    let sortByOrder = "asc";

    if (filters.sortBy === column && filters.sortByOrder === "asc") {
      sortByOrder = "desc";
    }

    var data = {
      sortBy: column.toLowerCase(),
      sortByOrder: sortByOrder,
      offset: 0,
      limit: 15,
      application: this.state.filters.application,
      subscriptionStatus: this.state.filters.subscriptionStatus,
      purchasedDate: this.state.filters.purchasedDate,
    };
    this.state.groupedColumn = null;
    this.state.normalData = [];
    this.state.groupedData = {};
    this.state.filters.sortBy = column;
    this.state.filters.sortByOrder = sortByOrder;
    this.state.filtered = data;
    let tableLoader = true;
    this.getAllApplicationData(data, tableLoader);
  };

  handleUserSort = (column) => {
    let { roleFilters } = this.state;
    let sortByOrder = "asc";

    if (roleFilters.sortBy === column && roleFilters.sortByOrder === "asc") {
      sortByOrder = "desc";
    }

    const data = {
      sortBy: column.toLowerCase(),
      sortByOrder: sortByOrder,
    };

    // Update roleFilters in state using setState for immutability
    this.setState(
      {
        roleFilters: {
          ...roleFilters,
          sortBy: column,
          sortByOrder: sortByOrder,
        },
        isloading: true, // Start loader
      },
      () => {
        // Call the API to fetch application status
        this.props
          .dispatch(
            getApplicationLicenseStatus(
              this.state.selectedItem.applicationId,
              data.sortBy,
              data.sortByOrder
            )
          )
          .then(() => {
            console.log("getApplicationLicenseStatus successful");
            this.setState({ isloading: false }); // Stop loader after API call completes
          })
          .catch((error) => {
            console.error("Failed to fetch application status:", error);
            this.setState({ isloading: false }); // Stop loader on error
          });
      }
    );
  };

  handleUserChange = (event, newValue) => {
    if (this.state.availableLicense > 0) {
      console.log("hello");
      if (newValue) {
        const { admins } = this.state;
        const isAlreadyAdded = admins.some(
          (admin) => admin.email === newValue.email
        );
        if (!isAlreadyAdded) {
          console.log(newValue);
          this.state.selectedUserEmails.push(newValue);
          this.setState({
            rolebasedtableuser: [...this.state.rolebasedtableuser, newValue],
            selectedUserss: "",
          });
        }
      }
    } else {
      console.log("NOT AVAILABLE LICENSE");
      this.customToast("LICENSE IS NOT AVAILABLE");
    }
  };
  cancellicense = () => {
    this.setState({
      editLicense: false,
      invalidLicense: false,
      mockTotallicense: this.state.totalLicense,
    });
  };

  savelicense = async (event) => {
    event.preventDefault();

    console.log(this.state.totalLicense);
    await this.props
      .dispatch(
        licensePurchase(this.state.apprefernceid, this.state.mockTotallicense)
      )
      .then(async (res) => {
        console.log(res);
        this.setState({
          editLicense: false,
          invalidLicense: false,
          totalLicense: this.state.mockTotallicense,
        });
        this.customToast("License Updated");
        // await this.getApplication()
      });
  };
  handleCheckboxChange = (email, applicationRoleUserId) => {
    this.setState((prevState) => {
      const { selectedEmails } = prevState;
      if (selectedEmails.includes(applicationRoleUserId)) {
        return {
          selectedEmails: selectedEmails.filter(
            (e) => e !== applicationRoleUserId
          ),
        };
      } else {
        return { selectedEmails: [...selectedEmails, applicationRoleUserId] };
      }
    });
  };

  handleDelete = () => {
    const { selectedEmails } = this.state;

    console.log("Delete selected users:", selectedEmails);
    this.props
      .dispatch(
        userRemoveTable(
          this.state.apprefernceid,
          this.state.rolebasedId,
          selectedEmails
        )
      )
      .then((res) => {
        this.setState({ selectedEmails: [] });
        this.getApplication();
        this.customToast("User deleted");
      });
  };
  editapplicationrole = (rolebasedId) => {
    console.log(rolebasedId);
    this.setState({ rolebasedId: rolebasedId });
    this.props
      .dispatch(roleBasedUsers(this.state.apprefernceid, rolebasedId))
      .then((res) => {
        this.setState({
          rolebasedtableuser: res.data,
          rolebasedId: rolebasedId,
        });
      });
  };
  savetable = () => {
    console.log(this.state.selectedUserEmails);
    this.setState({ totalLicense: this.state.totalLicense });
    let data = [];
    this.state.selectedUserEmails.map((e, i) => {
      data.push(e.userId);
    });
    console.log(data);

    this.props
      .dispatch(
        userRoleAssign(this.state.apprefernceid, this.state.rolebasedId, data)
      )
      .then((res) => {
        this.getApplication();
        this.setState({ selectedUserEmails: [], editTable: false });
        this.customToast("User added");
      });
  };
  edittable = () => {
    this.setState({ editTable: !this.state.editTable });
  };

  allselect = (e) => {
    // this.setState({allselect})
    console.log(e);
    if (e) {
      console.log(this.state.rolebasedtableuser);
      this.state.rolebasedtableuser.map((e, i) => {
        this.setState((prevState) => ({
          selectedEmails: [
            ...prevState.selectedEmails,
            e.applicationRoleUserId,
          ],
        }));
      });
    } else {
      this.setState((prevState) => ({
        selectedEmails: [],
      }));
    }
  };

  openDetails = (value) => {
    this.newFormShow();
    this.listviewtableapplication(value);
  };

  listviewtableapplication = (value) => {
    console.log(value);

    this.setState({ choosedProduct: value.name });
    if (value.subcriptionStatus == "") {
      this.setState({ subscriptionTable: true, unsubscriptionTable: false });
    } else {
      this.setState({ unsubscriptionTable: true, subscriptionTable: false });
    }
  };

  noUnsubscribeAction = () => {
    this.setState({
      opendialogun: false,
    });
  };

  yesUnsubscribeAction = () => {
    this.setState({
      opendialogun: false,
    });
    this.props.dispatch(Unsubscribe(this.state.clientId)).then((res) => {
      this.customToast("Application Unsubcribed");
      this.getApplication();
      this.closeForm();
    });
  };

  unsubscribe = () => {
    console.log(this.state.clientId);
    this.setState({
      opendialogun: true,
    });
  };

  trial = (clientId) => {
    console.log(this.state.clientId);
    this.setState({
      clientId: clientId,
    });
    let data = {
      sortBy: this.state.filters.sortBy,
      sortByOrder: this.state.filters.sortByOrder,
      pageNumber: this.state.filters.pageNumber,
      pageSize: this.state.filters.PageSize,
      application: this.state.filters.application,
      subscriptionStatus: this.state.filters.subscriptionStatus,
    };
    this.props
      .dispatch(Trial(clientId))
      .then((res) => {
        this.customToast("Trail Applied");
        this.setState({
          applicationIdNavigate: res.id,
        });
        // const { navigate } = this.props;
        // navigate(`/subscription?appId=${res.id}`);
        this.props
          .dispatch(allApplication(data))
          .then((response) => {
            console.log(response.data);
            this.setState({ normalData: response.data });
            // window.location.href=`/subscription?`
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  subscribePrroduct = () => {
    let data = {
      sortBy: this.state.filters.sortBy,
      sortByOrder: this.state.filters.sortByOrder,
      pageNumber: this.state.filters.pageNumber,
      pageSize: this.state.filters.PageSize,
      application: this.state.filters.application,
      subscriptionStatus: this.state.filters.subscriptionStatus,
    };
    // this.props.dispatch(Subscribe(this.state.clientId)).then((res) => {
    //     this.customToast("Subscribed Successfully")
    //     console.log(res.id);
    //     this.setState({
    //         applicationIdNavigate: res.id,
    //         apprefernceid: res.id
    //     })
    //     this.props.dispatch(licensePurchase(res.id, this.state.mockTotallicense)).then((res) => {
    //         this.setState({ editLicense: false, invalidLicense: false, totalLicense: this.state.mockTotallicense })

    //         this.getApplication()
    //     })

    //     this.props.dispatch(allApplication(data)).then((response) => {
    //         console.log(response.data);
    //         this.setState({ normalData: [] })
    //         this.setState({ normalData: response.data })
    //         this.closeForm()
    //         this.newOrderPlaceFormShow()
    //     })

    // }) //commented for disabling the function for now
  };

  formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" }); // e.g., 'Jul'
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";

    // Convert hours from 24-hour to 12-hour format
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${day} ${month} ${year} `;
  };

  trialForm = (element) => {
    console.log(element);

    this.props
      .dispatch(GetDetails(element.clientId))
      .then((res) => {
        console.log(res.data);
        this.setState({
          productsDetails: res.data,
          selectedPlanId: res.data[0].planId,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    this.setState({
      applicationname: element.name,
      clientId: element.clientId,
      trialproduct: true,
      buyproduct: false,
      trailstart: true,
      buystart: false,
    });

    this.TrialFormShow();
  };
  buyProduct = (element) => {
    console.log(element, "elee,,meth");
    // let data={
    //   planId:this.state.selectedPlanId,
    //   licenseCount:this.state.mockTotallicense
    // }
    // this.props.dispatch(TryOrBuyProducts(this.state.clientId,data)).then((res)=>{
    //   this.setState({
    //     totalLicense:this.state.mockTotallicense,
    //     applicationIdNavigate: res.id,
    //     apprefernceid: res.id
    //   })
    //   this.getApplication()
    //   this.newOrderPlaceFormShow()
    // })

    this.props.dispatch(GetDetails(element.clientId)).then((res) => {
      console.log(res.data);
      this.setState({
        productsDetails: res.data,
        selectedPlanId: res.data[1].planId,
      });
    });
    this.setState({
      applicationname: element.name,
      clientId: element.clientId,
      trialproduct: false,
      buyproduct: true,
      trailstart: false,
      buystart: true,
    });
    this.newTrialFormShow();
  };
  handleChangeradio = (event) => {
    this.setState({ radiovalue: event.target.value });
  };
  startTrial = () => {
    console.log(this.state.clientId);

    this.props.dispatch(Trial(this.state.clientId)).then((res) => {
      this.setState(
        {
          applicationIdNavigate: res.id,
          apprefernceid: res.id,
        },
        () => {
          this.getApplication();
        }
      );
      this.setState({
        editLicense: false,
        invalidLicense: false,
        totalLicense: this.state.mockTotallicense,
      });

      this.newOrderPlaceFormShow();
    });
  };
  subscribeNavigate = () => {
    const { navigate } = this.props;
    navigate(`/subscription?appId=${this.state.applicationIdNavigate}`);
  };

  buystarted = () => {
    this.setState({
      buyproduct: true,
      trialproduct: false,
    });
  };

  trialstarted = () => {
    this.setState({
      buyproduct: false,
      trialproduct: true,
    });
  };

  onradioChange = (event, name) => {
    console.log(name);
    if (name.includes("Trial")) {
      this.setState({ trailstart: true, buystart: false });
    } else {
      this.setState({ trailstart: false, buystart: true });
    }
    this.setState({
      selectedPlanId: event.target.value, // Update state with the selected radio button value
    });
  };

  render() {
    let maindiv = $("#maindiv").width();
    const { selectedEmails } = this.state;
    const { admins, users, selectedUserss, logs } = this.state;
    let {
      isWebMobile,
      isloading,
      opendialog,
      isAddingResource,
      selectedRoleId,
      isEditing,
      selectedUser,
    } = this.state;
    const selectedItem = this.state.selectedItem || {};
    const selectedRole = selectedItem.roles?.find(
      (role) => role.roleId === selectedRoleId
    );

    return (
      <>
        {$("#AddScreen").hasClass("show") ? (
          <div className="viewbar-overlay"></div>
        ) : (
          <></>
        )}
        {isWebMobile || this.state.isMobile ? (
          <>
            <ToastContainer className="toast-container" />
            <Backdrop className="spinner-backdrop" open={isloading}>
              <CircularProgress color="primary" />
            </Backdrop>
            {isWebMobile && (
              <div className="row">
                <div className="row">
                  <div className="col-1 pe-0">
                    <span
                      className="mobile-menuprod"
                      onClick={() => this.props.toggleMenu()}
                    >
                      <CommonIcon fileName={"Menu"} />
                    </span>
                  </div>
                  <div className="col-6 ps-3">
                    <span className="headerform-mobile">Products</span>
                  </div>
                  <div className="col-5  pt-2 pe-0">
                    <div className="btn-container float-end">
                      <button
                        className="btn-funfilter  ps-3 pe-3 float-end"
                        type="button"
                        onClick={this.toggleWebFilter}
                      >
                        <CommonIcon
                          fileName={
                            this.state.isFilterApplied ? "Filtered" : "Filter"
                          }
                        />
                      </button>{" "}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {!isWebMobile && (
              <div className="row tapbar">
                <div className="col-5">
                  <span className="headerform">Products</span>
                </div>
                <div className="col-7">
                  <div className="btn-container float-end mt-2">
                    <button
                      className="btn-funfilter mr-33 ps-3 pe-3"
                      type="button"
                      onClick={this.toggleWebFilter}
                    >
                      <CommonIcon
                        fileName={
                          this.state.isFilterApplied ? "Filtered" : "Filter"
                        }
                      />
                    </button>{" "}
                  </div>
                </div>
              </div>
            )}

            {this.state.isFilterApplied && (
              <>
                <div className="mt-3 mb-0" style={{ paddingRight: "2rem" }}>
                  {this.state.filteredOptions.application &&
                    this.state.filteredOptions.application.map((data) => (
                      <span className="filteredBadgeApp">
                        <span>{data?.name}</span>
                        <span
                          onClick={() => {
                            this.applyFilterProducts(data.applicationId);
                          }}
                          className="ms-2"
                        >
                          <CommonIcon fileName={"CloseSmallwhite"} />
                        </span>
                      </span>
                    ))}
                  {this.state.filteredOptions.subscriptionStatus !== "" &&
                    this.state.filteredOptions.subscriptionStatus !== null && (
                      <span className="filteredBadge">
                        <span>
                          Status -{" "}
                          {this.state.filteredOptions.subscriptionStatus}
                        </span>
                        <span onClick={this.applyFilterStatus} className="ms-2">
                          <CommonIcon fileName={"CloseSmallwhite"} />
                        </span>
                      </span>
                    )}
                  {this.state.filteredOptions.purchasedDate !== "" &&
                    this.state.choice.purchasedDate !== null && (
                      <span className="filteredBadge">
                        <span>Purchased Date</span>
                        <span onClick={this.applyFilterDate} className="ms-2">
                          <CommonIcon fileName={"CloseSmallwhite"} />
                        </span>
                      </span>
                    )}
                </div>
                <p className="mb-0 mt-2 countValue">
                  Count: {this.state.normalData.length}
                </p>
              </>
            )}

            <div className="prodcardmobile">
              {this.state.normalData.length > 0 ? (
                this.state.normalData.map((element, inde) => {
                  if (
                    element.subcriptionStatus == "Subscribed" ||
                    element.subcriptionStatus == "Trial"
                  ) {
                    return (
                      <div
                        className="card sharpcorner  cursor-pointer px-2 my-2 mt-2  pb-1 pt-1 "
                        style={{ width: "100%" }}
                        onClick={() =>
                          this.handleEditId(
                            element.id,
                            element.clientId,
                            element.subcriptionStatus,
                            element.trialExpiryDate,
                            element.trialStartDate,
                            element.subscriptionStartDate
                          )
                        }
                      >
                        <div className="card-body">
                          <div
                            style={{
                              position: "absolute",
                              left: "0",
                              top: "-0.1px",
                              bottom: "-0.2px",
                              width: "5px",
                              backgroundColor: element.colorCode,
                            }}
                          ></div>
                          <div className="row">
                            <div className="col-lg-12 col-md-12 col-12 d-flex align-items-center">
                              <div className="row">
                                <div className="col-12">
                                  <span
                                    className="reporttext14"
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {element?.name}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-6 d-flex align-items-center">
                              <div className="row ">
                                <div className="col-12">
                                  <span className="reporttext14">Status</span>
                                </div>
                                <div className="col-12">
                                  <span className="reporttext121">
                                    {element.subcriptionStatus}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-6 d-flex align-items-center">
                              <div className="row ">
                                <div className="col-12">
                                  <span className="reporttext14">
                                    Available License
                                  </span>
                                </div>
                                <div className="col-12">
                                  <span className="reporttext12">
                                    {element.purchasedQuantity -
                                      element.assignedLicense}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-6 d-flex align-items-center">
                              <div className="row ">
                                <div className="col-12">
                                  <span className="reporttext14">
                                    Assigned License
                                  </span>
                                </div>
                                <div className="col-12">
                                  <span className="reporttext12">
                                    {element.assignedLicense}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {element.subcriptionStatus == "Trial" ? (
                              <div className="col-3 d-flex align-items-center">
                                <div className="row ">
                                  <span className="tryapplicationbtn underlinehover">
                                    Upgrade
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <div className="col-3 d-flex align-items-center">
                                <div className="row ">
                                  <div className="col-12">
                                    <span className="reporttext14">
                                      Purchased Date
                                    </span>
                                  </div>

                                  <div className="col-12">
                                    <span className="reporttext12 ">
                                      {this.formatDate(
                                        element.subscriptionStartDate
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* <div className="col-lg-1 col-md-3 col-4 d-flex align-items-center justify-content-end">
                          <div className="row ">
                            <CommonIcon fileName={'Arrownext'} />
                          </div>
                        </div> */}
                          </div>
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div
                        className="card sharpcorner px-2 my-2 mt-2  "
                        style={{ width: "94%" }}
                      >
                        <div className="card-body p-3">
                          <div
                            style={{
                              position: "absolute",
                              left: "0",
                              top: "-0.1px",
                              bottom: "-0.2px",
                              width: "5px",
                              backgroundColor: element.colorCode,
                            }}
                          ></div>
                          <div className="row">
                            <div className="col-12 d-flex align-items-center">
                              <div className="row">
                                <div className="col-12">
                                  <span
                                    className="reporttext14"
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {element.name}
                                  </span>
                                </div>
                                {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                              </div>
                            </div>
                            <div className="col-6 d-flex align-items-center">
                              <div className="row ">
                                <div className="col-12">
                                  <span className="reporttext14">Status</span>
                                </div>
                                <div className="col-12">
                                  <span className="reporttext12un ">
                                    {element.subcriptionStatus}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className=" col-3 d-flex align-items-center">
                              <div className="row ">
                                {/* <span className="tryapplicationbtn cursor-pointer" onClick={() => this.subscribe(element.clientId)}>Try</span> */}
                                <span
                                  className={`tryapplicationbtn  ${
                                    element?.isEnabled
                                      ? "cursor-pointer underlinehover"
                                      : "disabled-btn1"
                                  } `}
                                  onClick={() => this.trialForm(element)}
                                >
                                  Try
                                </span>
                              </div>
                            </div>
                            <div className="col-3 d-flex align-items-center">
                              <div className="row ">
                                {/* <span className="Buybtn cursor-pointer" onClick={() => this.subscribePrroduct(element.clientId)}>Buy</span> */}
                                <span
                                  className="Buybtn disabled-btn"
                                  onClick={() => this.buyProduct(element)}
                                >
                                  Buy
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })
              ) : !isloading ? (
                <div
                  className="card sharpcorner  cursor-pointer px-2 my-2 mt-2 p-2"
                  style={{ width: "94%" }}
                >
                  <div className="card-body">
                    <div
                      style={{
                        position: "absolute",
                        left: "0",
                        top: "-0.1px",
                        bottom: "-0.2px",
                        width: "4px",
                        backgroundColor: " rgb(33, 150, 243)",
                      }}
                    ></div>
                    <div className="row">
                      <div className="col-lg-12 col-md-5 col-5 d-flex align-items-center">
                        <div className="row text-center w-100">
                          <div className="col-12">
                            <span
                              className="nofound "
                              style={{ fontWeight: "bold" }}
                            >
                              No products found
                            </span>
                          </div>
                          {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>

            {/* Trial view */}

            <div
              className="offcanvas offcanvas-end"
              data-bs-scroll="false"
              data-bs-backdrop
              id="trialscreen"
              aria-labelledby="offcanvasScrollingLabel"
              style={{
                width: "calc(100% - 240px)",
                overflowX: "hidden",
                height: "100vh",
              }}
            >
              <div className={`offcanvas-header  px-4`}>
                <h3 className="applicationnametrial">
                  {this.state.applicationname}
                </h3>

                <button
                  data-bs-dismiss="offcanvas"
                  className="offcavasclose"
                  onClick={() => this.closeFormlic()}
                >
                  <CommonIcon fileName={"Close"} />
                </button>
              </div>
              <div className="row p-4 ps-1 pt-2 ps-4 pb-0">
                <div className="col-12">
                  <div className="col-12">
                    <FormLabel className="formlabel-style2 ">
                      Select a plan
                    </FormLabel>
                    <br />

                    {this.state.productsDetails.map((e) => {
                      return (
                        <>
                          <div className="d-flex align-items-start">
                            <input
                              type="radio"
                              value={e.planId}
                              className="radioinputtrial"
                              name="plan"
                              checked={this.state.selectedPlanId === e.planId}
                              onChange={(event) =>
                                this.onradioChange(event, e.planName)
                              }
                            />
                            <label className="radiolabel">{e.planName}</label>
                          </div>
                        </>
                      );
                    })}
                    <div className="col-12 mt-2">
                      <div className="d-flex">
                        <FormLabel className="formlabel-style2">
                          License Quantity{" "}
                        </FormLabel>
                      </div>
                      <div
                        className={` flex-wrap  align-items-start`}
                        id="licenseinput"
                      >
                        <TextField
                          className="number-field-1 mb-2"
                          value={this.state.mockTotallicense}
                          onChange={this.handleChange}
                          InputProps={{
                            inputProps: { min: 0 },
                            endAdornment: (
                              <InputAdornment position="end">
                                <div className="adornment-container">
                                  <div
                                    onClick={this.handleIncrement}
                                    className="cursor-pointer "
                                  >
                                    <CommonIcon fileName={"ArrowUpIcon"} />
                                  </div>
                                  <div
                                    onClick={() => this.handleDecrement()}
                                    className="cursor-pointer "
                                  >
                                    <CommonIcon fileName={"ArrowDownIcon"} />
                                  </div>
                                </div>
                              </InputAdornment>
                            ),
                          }}
                        />
                        <br />

                        {this.state.invalidLicense ? (
                          <label className="isrequired invalidlabel">
                            All license are assigned to users.
                          </label>
                        ) : (
                          ""
                        )}
                      </div>
                      {this.state.trailstart ? (
                        <>
                          <FormLabel className="formlabel-style2">
                            Subscription period
                          </FormLabel>
                          <span className="subperiod">
                            &nbsp;-&nbsp;&nbsp;&nbsp; 1 month
                          </span>
                        </>
                      ) : (
                        ""
                      )}

                      {this.state.buystart ? (
                        <div className="mt-2">
                          <FormLabel className="formlabel-style2">
                            Subscription period
                          </FormLabel>
                          <div className="d-flex align-items-start">
                            <input
                              type="radio"
                              value="1 Month"
                              className="radioinputtrial"
                              checked
                            />
                            <label className="radiolabel">1 Month</label>
                          </div>
                          <div className="d-flex align-items-start mt-1">
                            {" "}
                            <input type="radio" value="1 Year" />
                            <label className="radiolabel">1 Year</label>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {this.state.productsDetails.map((e) => {
                      if (e.planId == this.state.selectedPlanId) {
                        if (e.subscriptionPeriod.length == 1) {
                          <>
                            <div>
                              <FormLabel className="formlabel-style2">
                                Subscription period
                              </FormLabel>
                              <span className="subperiod">
                                &nbsp;-&nbsp;&nbsp;&nbsp; 1 month{" "}
                              </span>
                            </div>
                            <button
                              className="btn-fun ps-3 p-2 pe-3 fs-7 mt-2"
                              onClick={() => this.startTrial()}
                            >
                              Start Trial
                            </button>
                          </>;
                        } else {
                          <>
                            {e.subscriptionPeriod.map((e) => {
                              <>
                                <FormLabel className="formlabel-style2">
                                  Subscription period
                                </FormLabel>
                                <div className="d-flex align-items-start">
                                  <input
                                    type="radio"
                                    value={e.periodId}
                                    className="radioinputtrial"
                                    checked
                                  />
                                  <label className="radiolabel">
                                    {e.periodName}
                                  </label>
                                </div>
                              </>;
                            })}
                            <button
                              className="btn-fun ps-3 p-2 pe-3 fs-7 mt-3"
                              onClick={this.subscribePrroduct}
                            >
                              Subscribe
                            </button>
                          </>;
                        }
                      }
                    })}

                    {/* <div className="d-flex align-items-start"><input type="radio" value={this.state.applicationname} className="radioinputtrial" name="plan" onChange={this.buyProduct} /><label className="radiolabel">{this.state.applicationname}</label></div>
                      <div className="d-flex align-items-start mt-1"> <input type="radio" value={this.state.applicationname + '- Trail'} name="plan" onChange={this.trialstarted} /><label className="radiolabel">{this.state.applicationname + '- Trail '}</label></div> */}
                  </div>

                  {this.state.trailstart && (
                    <button
                      className="btn-fun ps-3 p-2 pe-3 fs-7 mt-2"
                      onClick={() => this.startTrial()}
                    >
                      Start Trial
                    </button>
                  )}
                </div>
              </div>
              <div className="row ps-3">
                {this.state.productsDetails.map((e) => {
                  if (this.state.buystart) {
                    if (e.pricingDetails != null) {
                      return (
                        <div className="row p-4  pt-2 ps-4 pb-2 ">
                          <hr className="hrproducts" />
                          <div className="col-12 ps-2 ">
                            <h3 className="licenseheader">Pricing details</h3>
                          </div>
                          <div className="col-10 pt-0 ps-2">
                            <div className="col-12">
                              <FormLabel className="formlabel-style1 d-block">
                                Billing account{" "}
                              </FormLabel>
                              <span className={`formlabel-input`}>
                                {e.pricingDetails.billingAccount}
                              </span>
                            </div>
                            <div className="col-12 mt-2">
                              <FormLabel className="formlabel-style1 d-block">
                                Register number{" "}
                              </FormLabel>
                              <span className={`formlabel-input`}>
                                8773498437
                              </span>
                            </div>
                            <div className="col-12 mt-2">
                              <FormLabel className="formlabel-style1 d-block">
                                Bill to{" "}
                              </FormLabel>
                              <span className={`formlabel-input`}>
                                {e.pricingDetails.billToName}
                              </span>
                            </div>
                          </div>
                          <div className="col-2">
                            <span className="isedit cursor-pointer float-end ">
                              <CommonIcon fileName={"editicon"} />
                            </span>
                          </div>
                        </div>
                      );
                    }
                  }
                })}
                {this.state.productsDetails.map((e) => {
                  if (this.state.buystart) {
                    if (e.summary != null) {
                      return (
                        <div className="row p-4 ps-1 pb-0 ps-4 pt-0">
                          <hr className="hrproducts" />
                          <div className="col-12">
                            <h3 className="licenseheader">Summary</h3>
                          </div>
                          <div className="col-12 pt-0">
                            <div className="col-12">
                              <FormLabel className="formlabel-style1 col-10 d-block">
                                Monthly plan, paid monthly after trail (before
                                tax):{" "}
                              </FormLabel>
                              <span className={`formlabel-input col-2`}>
                                &#8377;{e.summary.monthlyAmount}
                              </span>
                            </div>
                            <div className="col-12 mt-2">
                              <FormLabel className="formlabel-style1 col-10 d-block">
                                Estimated taxes:{" "}
                              </FormLabel>
                              <span className={`formlabel-input col-2`}>
                                &#8377;{e.summary.tax}
                              </span>
                            </div>
                            <div className="col-12 mt-2">
                              <FormLabel className="formlabel-style1 col-10 d-block">
                                Total paid monthly after trail (Annual plan):
                              </FormLabel>
                              <span className={`formlabel-input col-2`}>
                                &#8377;{e.summary.totalPaid}
                              </span>
                            </div>
                            <div className="col-12 mt-2">
                              <FormLabel className="formlabel-style1 col-10 d-block">
                                Total today:
                              </FormLabel>
                              <span className={`formlabel-input col-2`}>
                                &#8377;{e.summary.totalToday.toFixed(2)}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  }
                })}
              </div>
              <div className="row p-4 ps-1 pt-0 ps-4 pb-0 ">
                <div className="col-12">
                  {this.state.buystart && (
                    <button
                      className="btn-fun ps-3 p-2 pe-3 fs-7 mt-3"
                      onClick={this.subscribePrroduct}
                    >
                      Subscribe
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* New form */}

            {/* Edit Job */}

            {/* filter offcanvas */}
          </>
        ) : (
          <>
            <div className="appmain">
              <div className="content-header">
                <Backdrop className="spinner-backdrop" open={isloading}>
                  <CircularProgress color="primary" />
                </Backdrop>
                <ToastContainer />
                <div className="w-100 pr">
                  <div className="row tapbar" style={{ paddingRight: "2rem" }}>
                    <div className="col-5">
                      <span className="headerform">Products</span>
                    </div>
                    <div className="col-lg-7 col-sm-7 col-md-7 col-lg-7 d-flex justify-content-end pt-2 pr-5 pe-2">
                      <div className="btn-container">
                        <button
                          className="btn-funfilter1  ps-3 pe-3"
                          type="button"
                          onClick={this.toggleWebFilter}
                        >
                          <CommonIcon
                            fileName={
                              this.state.isFilterApplied ? "Filtered" : "Filter"
                            }
                          />
                        </button>{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {this.state.isFilterApplied && (
                <>
                  <div className="mt-3 mb-0" style={{ paddingRight: "2rem" }}>
                    {this.state.filteredOptions.application &&
                      this.state.filteredOptions.application.map((data) => (
                        <span className="filteredBadgeApp">
                          <span>{data?.name}</span>
                          <span
                            onClick={() => {
                              this.applyFilterProducts(data.applicationId);
                            }}
                            className="ms-2"
                          >
                            <CommonIcon fileName={"CloseSmallwhite"} />
                          </span>
                        </span>
                      ))}
                    {this.state.filteredOptions.subscriptionStatus !== "" &&
                      this.state.filteredOptions.subscriptionStatus !==
                        null && (
                        <span className="filteredBadge">
                          <span>
                            Status -{" "}
                            {this.state.filteredOptions.subscriptionStatus}
                          </span>
                          <span
                            onClick={this.applyFilterStatus}
                            className="ms-2"
                          >
                            <CommonIcon fileName={"CloseSmallwhite"} />
                          </span>
                        </span>
                      )}
                    {this.state.filteredOptions.purchasedDate !== "" &&
                      this.state.choice.purchasedDate !== null && (
                        <span className="filteredBadge">
                          <span>Purchased Date</span>
                          <span onClick={this.applyFilterDate} className="ms-2">
                            <CommonIcon fileName={"CloseSmallwhite"} />
                          </span>
                        </span>
                      )}
                  </div>
                  <p className="mb-0 mt-2 countValue">
                    Count: {this.state.normalData.length}
                  </p>
                </>
              )}

              <div
                className="mt-2 productoverflow"
                style={{ marginRight: "2rem" }}
              >
                {this.state.normalData.length > 0 ? (
                  this.state.normalData.map((element, inde) => {
                    if (
                      element.subcriptionStatus == "Subscribed" ||
                      element.subcriptionStatus == "Trial"
                    ) {
                      return (
                        <div
                          className="card sharpcorner1 cursor-pointer px-2 my-2 mt-2 "
                          onClick={() =>
                            this.handleEditId(
                              element.id,
                              element.clientId,
                              element.subcriptionStatus,
                              element.trialExpiryDate,
                              element.trialStartDate,
                              element.subscriptionStartDate
                            )
                          }
                        >
                          <div className="card-body">
                            <div
                              style={{
                                position: "absolute",
                                left: "0",
                                top: "-0.1px",
                                bottom: "-0.2px",
                                width: "4px",
                                backgroundColor: element.colorCode,
                              }}
                            ></div>
                            <div className="row">
                              <div className="col-lg-3 col-md-12  col-sm-12 d-flex align-items-center">
                                <div className="row">
                                  <div className="col-12">
                                    <span
                                      className="reporttext14"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      {element.name}
                                    </span>
                                  </div>
                                  {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                                </div>
                              </div>
                              <div className="col-lg-2 col-md-2 col-sm-6  d-flex align-items-center">
                                <div className="row ">
                                  <div className="col-12">
                                    <span className="reporttext14">Status</span>
                                  </div>
                                  <div className="col-12">
                                    <span className="reporttext121">
                                      {element.subcriptionStatus}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-2 col-md-3  col-sm-6 d-flex align-items-center">
                                <div className="row ">
                                  <div className="col-12">
                                    <span className="reporttext14">
                                      Available License
                                    </span>
                                  </div>
                                  <div className="col-12">
                                    <span className="reporttext12">
                                      {element.purchasedQuantity -
                                        element.assignedLicense}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-2 col-md-3  col-sm-6 d-flex align-items-center">
                                <div className="row ">
                                  <div className="col-12">
                                    <span className="reporttext14">
                                      Assigned License
                                    </span>
                                  </div>
                                  <div className="col-12">
                                    <span className="reporttext12">
                                      {element.assignedLicense}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              {element.subcriptionStatus == "Trial" ? (
                                <div className="col-lg-2 col-md-3  col-sm-6 d-flex align-items-center">
                                  <div className="row ">
                                    <span className="tryapplicationbtn underlinehover">
                                      Upgrade
                                    </span>
                                  </div>
                                </div>
                              ) : (
                                <div className="col-lg-2 col-md-3  col-sm-5 d-flex align-items-center">
                                  <div className="row ">
                                    <div className="col-12">
                                      <span className="reporttext14">
                                        Purchased Date
                                      </span>
                                    </div>

                                    <div className="col-12">
                                      <span className="reporttext12 ">
                                        {this.formatDate(
                                          element.subscriptionStartDate
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )}

                              <div className="col-lg-1 col-md-1 col-sm-1  d-flex align-items-center justify-content-end">
                                <div className="row ">
                                  <CommonIcon
                                    className="float-end"
                                    fileName={"Arrownext"}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    } else if (element.subcriptionStatus == "Trial ends in") {
                      return (
                        <div className="card sharpcorner1 px-2 my-2 mt-2  ">
                          <div className="card-body p-3">
                            <div
                              style={{
                                position: "absolute",
                                left: "0",
                                top: "-0.1px",
                                bottom: "-0.2px",
                                width: "4px",
                                backgroundColor: element.colorCode,
                              }}
                            ></div>
                            <div className="row">
                              <div className="col-lg-3 col-md-12 col-sm-12  d-flex align-items-center">
                                <div className="row">
                                  <div className="col-12">
                                    <span
                                      className="reporttext14"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      {element.name}
                                    </span>
                                  </div>
                                  {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                                </div>
                              </div>
                              <div className="col-lg-2 col-md-4 col-sm-4 col-6 d-flex align-items-center">
                                <div className="row ">
                                  <div className="col-12">
                                    <span className="reporttext14">Status</span>
                                  </div>
                                  <div className="col-12">
                                    <span className="reporttext12un ">
                                      {element.subcriptionStatus}{" "}
                                      {element.daysToExpire} days
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-2 col-md-3  col-sm-6 d-flex align-items-center">
                                <div className="row ">
                                  <div className="col-12">
                                    <span className="reporttext14">
                                      Available License
                                    </span>
                                  </div>
                                  <div className="col-12">
                                    <span className="reporttext12">
                                      {element.purchasedQuantity -
                                        element.assignedLicense}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-2 col-md-3  col-sm-6 d-flex align-items-center">
                                <div className="row ">
                                  <div className="col-12">
                                    <span className="reporttext14">
                                      Assigned License
                                    </span>
                                  </div>
                                  <div className="col-12">
                                    <span className="reporttext12">
                                      {element.assignedLicense}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-2 col-md-4 col-sm-4 col-6 d-flex align-items-center">
                                <span
                                  className={`tryapplicationbtn  ${
                                    element?.isEnabled
                                      ? "cursor-pointer underlinehover"
                                      : "disabled-btn1"
                                  } `}
                                  onClick={() => this.trialForm(element)}
                                >
                                  Try
                                </span>
                                <span
                                  className="Buybtn1 disabled-btn"
                                  onClick={() => this.buyProduct(element)}
                                >
                                  Buy
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div className="card sharpcorner1 px-2 my-2 mt-2  ">
                          <div className="card-body p-3">
                            <div
                              style={{
                                position: "absolute",
                                left: "0",
                                top: "-0.1px",
                                bottom: "-0.2px",
                                width: "4px",
                                backgroundColor: element.colorCode,
                              }}
                            ></div>
                            <div className="row">
                              <div className="col-lg-3 col-md-12 col-sm-12  d-flex align-items-center">
                                <div className="row">
                                  <div className="col-12">
                                    <span
                                      className="reporttext14"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      {element.name}
                                    </span>
                                  </div>
                                  {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                                </div>
                              </div>
                              <div className="col-lg-2 col-md-4 col-sm-4 col-6 d-flex align-items-center">
                                <div className="row ">
                                  <div className="col-12">
                                    <span className="reporttext14">Status</span>
                                  </div>
                                  <div className="col-12">
                                    <span className="reporttext12un ">
                                      {element.subcriptionStatus}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-2 col-md-4 col-sm-4 col-6 d-flex align-items-center">
                                <div className="row ">
                                  {/* <span className="tryapplicationbtn cursor-pointer" onClick={() => this.subscribe(element.clientId)}>Try</span> */}
                                  <span
                                    className={`tryapplicationbtn  ${
                                      element?.isEnabled
                                        ? "cursor-pointer underlinehover"
                                        : "disabled-btn1"
                                    } `}
                                    onClick={() => this.trialForm(element)}
                                  >
                                    Try
                                  </span>
                                </div>
                              </div>
                              <div className="col-lg-2 col-md-4 col-sm-4 col-6 d-flex align-items-center">
                                <div className="row ">
                                  {/* <span className="Buybtn cursor-pointer" onClick={() => this.subscribePrroduct(element.clientId)}>Buy</span> */}
                                  <span
                                    className="Buybtn disabled-btn "
                                    onClick={() => this.buyProduct(element)}
                                  >
                                    Buy
                                  </span>
                                </div>
                              </div>

                              {/* <div className="col-lg-7 col-md-3 col-3 d-flex align-items-center">

                              <div className="col-lg-6"></div>
                              <div className="col-lg-6 d-flex ps-5">
                                <div className="col-lg-6 col-md-3 col-3 d-flex align-items-center ps-2">
                                  <button className="tryapplicationbtn cursor-pointer" onClick={() => this.subscribe(element.clientId)}>Try</button>
                                </div>
                                <div className="col-lg-6 col-md-3 col-3 d-flex align-items-center ps-3">
                                  <button className="Buybtn cursor-pointer" onClick={()=>this.subscribePrroduct(element.clientId)}>Buy</button>
                                </div>
                              </div>

                            </div> */}

                              {/* <div className="col-lg-1 col-md-3 col-4 d-flex align-items-center justify-content-end">
                              <div className="row ">
                                <CommonIcon fileName={'Arrownext'} />
                              </div>
                            </div> */}
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })
                ) : !isloading ? (
                  <div className="card sharpcorner1  cursor-pointer px-2 my-2 mt-2 p-2">
                    <div className="card-body">
                      <div
                        style={{
                          position: "absolute",
                          left: "0",
                          top: "-0.1px",
                          bottom: "-0.2px",
                          width: "4px",
                          backgroundColor: " rgb(33, 150, 243)",
                        }}
                      ></div>
                      <div className="row">
                        <div className="col-lg-12 col-md-5 col-5 d-flex align-items-center">
                          <div className="row text-center w-100">
                            <div className="col-12">
                              <span
                                className="nofound "
                                style={{ fontWeight: "bold" }}
                              >
                                No products found
                              </span>
                            </div>
                            {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>

              {/* Buynew view */}

              <div
                className="offcanvas offcanvas-end"
                data-bs-scroll="false"
                data-bs-backdrop
                id="trialscreen"
                aria-labelledby="offcanvasScrollingLabel"
                style={{
                  width: this.props.menuToggle
                    ? "calc(100% - 240px)"
                    : "calc(100% - 70px)",
                  overflowX: "hidden",
                  height: "100vh",
                }}
              >
                <div className={`offcanvas-header  px-4`}>
                  <h3 className="applicationnametrial">
                    {this.state.applicationname}
                  </h3>

                  <button
                    data-bs-dismiss="offcanvas"
                    className="offcavasclose"
                    onClick={() => this.closeFormlic()}
                  >
                    <CommonIcon fileName={"Close"} />
                  </button>
                </div>
                <div className="row p-4 ps-1 pt-2 ps-4 pb-0">
                  <div className="col-4">
                    <h3 className="licenseheader">Select plan details</h3>
                  </div>

                  <div className="col-6">
                    <div className="col-12">
                      <FormLabel className="formlabel-style2 ">
                        Select a plan
                      </FormLabel>
                      <br />

                      {this.state.productsDetails.map((e) => {
                        return (
                          <>
                            <div className="d-flex align-items-start">
                              <input
                                type="radio"
                                value={e.planId}
                                className="radioinputtrial"
                                name="plan"
                                checked={this.state.selectedPlanId === e.planId}
                                onChange={(event) =>
                                  this.onradioChange(event, e.planName)
                                }
                              />
                              <label className="radiolabel">{e.planName}</label>
                            </div>
                          </>
                        );
                      })}
                      <div className="col-12 mt-2">
                        <div className="d-flex">
                          <FormLabel className="formlabel-style2">
                            License Quantity{" "}
                          </FormLabel>
                        </div>
                        <div
                          className={` flex-wrap  align-items-start`}
                          id="licenseinput"
                        >
                          <TextField
                            className="number-field-1 mb-2"
                            value={this.state.mockTotallicense}
                            onChange={this.handleChange}
                            InputProps={{
                              inputProps: { min: 0 },
                              endAdornment: (
                                <InputAdornment position="end">
                                  <div className="adornment-container">
                                    <div
                                      onClick={this.handleIncrement}
                                      className="cursor-pointer "
                                    >
                                      <CommonIcon fileName={"ArrowUpIcon"} />
                                    </div>
                                    <div
                                      onClick={() => this.handleDecrement()}
                                      className="cursor-pointer "
                                    >
                                      <CommonIcon fileName={"ArrowDownIcon"} />
                                    </div>
                                  </div>
                                </InputAdornment>
                              ),
                            }}
                          />
                          <br />

                          {this.state.invalidLicense ? (
                            <label className="isrequired invalidlabel">
                              All license are assigned to users.
                            </label>
                          ) : (
                            ""
                          )}
                        </div>
                        {this.state.trailstart ? (
                          <>
                            <FormLabel className="formlabel-style2">
                              Subscription period
                            </FormLabel>
                            <span className="subperiod">
                              &nbsp;-&nbsp;&nbsp;&nbsp; 1 month
                            </span>
                          </>
                        ) : (
                          ""
                        )}

                        {this.state.buystart ? (
                          <div className="mt-2">
                            <FormLabel className="formlabel-style2">
                              Subscription period
                            </FormLabel>
                            <div className="d-flex align-items-start">
                              <input
                                type="radio"
                                value="1 Month"
                                className="radioinputtrial"
                                checked
                              />
                              <label className="radiolabel">1 Month</label>
                            </div>
                            <div className="d-flex align-items-start mt-1">
                              {" "}
                              <input type="radio" value="1 Year" />
                              <label className="radiolabel">1 Year</label>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      {this.state.productsDetails.map((e) => {
                        if (e.planId == this.state.selectedPlanId) {
                          if (e.subscriptionPeriod.length == 1) {
                            <>
                              <div>
                                <FormLabel className="formlabel-style2">
                                  Subscription period
                                </FormLabel>
                                <span className="subperiod">
                                  &nbsp;-&nbsp;&nbsp;&nbsp; 1 month{" "}
                                </span>
                              </div>
                              <button
                                className="btn-fun ps-3 p-2 pe-3 fs-7 mt-2"
                                onClick={() => this.startTrial()}
                              >
                                Start Trial
                              </button>
                            </>;
                          } else {
                            <>
                              {e.subscriptionPeriod.map((e) => {
                                <>
                                  <FormLabel className="formlabel-style2">
                                    Subscription period
                                  </FormLabel>
                                  <div className="d-flex align-items-start">
                                    <input
                                      type="radio"
                                      value={e.periodId}
                                      className="radioinputtrial"
                                      checked
                                    />
                                    <label className="radiolabel">
                                      {e.periodName}
                                    </label>
                                  </div>
                                </>;
                              })}
                              <button
                                className="btn-fun ps-3 p-2 pe-3 fs-7 mt-3"
                                onClick={this.subscribePrroduct}
                              >
                                Subscribe
                              </button>
                            </>;
                          }
                        }
                      })}

                      {/* <div className="d-flex align-items-start"><input type="radio" value={this.state.applicationname} className="radioinputtrial" name="plan" onChange={this.buyProduct} /><label className="radiolabel">{this.state.applicationname}</label></div>
                      <div className="d-flex align-items-start mt-1"> <input type="radio" value={this.state.applicationname + '- Trail'} name="plan" onChange={this.trialstarted} /><label className="radiolabel">{this.state.applicationname + '- Trail '}</label></div> */}
                    </div>
                    {/* <div className="col-12 mt-2">
                      <div className='d-flex'><FormLabel className="formlabel-style2">License Quantity </FormLabel></div>
                      <div className={` flex-wrap  align-items-start`} id="licenseinput">
                        <TextField
                          className="number-field-1 mb-2"
                          value={this.state.mockTotallicense}
                          onChange={this.handleChange}
                          InputProps={{
                            inputProps: { min: 0 },
                            endAdornment: (
                              <InputAdornment position="end">
                                <div className="adornment-container">
                                  <div onClick={this.handleIncrement} className="cursor-pointer ">
                                    <CommonIcon fileName={"ArrowUpIcon"} />
                                  </div>
                                  <div onClick={() => this.handleDecrement()} className="cursor-pointer ">
                                    <CommonIcon fileName={"ArrowDownIcon"} />
                                  </div>
                                </div>
                              </InputAdornment>
                            ),
                          }}
                        /><br />

                        {this.state.invalidLicense ? <label className="isrequired invalidlabel">All license are assigned to users.</label> : ""}
                      </div>
                      {this.state.trialproduct ?
                        <>
                          <FormLabel className="formlabel-style2">Subscription period</FormLabel><span className="subperiod">&nbsp;-&nbsp;&nbsp;&nbsp; 1 month</span>
                        </>
                        : ""}

                      {this.state.buyproduct ?
                        <div className="mt-2">
                          <FormLabel className="formlabel-style2">Subscription period</FormLabel>
                          <div className="d-flex align-items-start"><input type="radio" value='1 Month' className="radioinputtrial" checked /><label className="radiolabel">1 Month</label></div>
                          <div className="d-flex align-items-start mt-1"> <input type="radio" value='1 Year' /><label className="radiolabel">1 Year</label></div>

                        </div> : ""}

                    </div> */}

                    {this.state.trailstart && (
                      <button
                        className="btn-fun ps-3 p-2 pe-3 fs-7 mt-2"
                        onClick={() => this.startTrial()}
                      >
                        Start Trial
                      </button>
                    )}
                  </div>
                </div>
                <div className="row ps-3">
                  {this.state.productsDetails.map((e) => {
                    if (this.state.buystart) {
                      if (e.pricingDetails != null) {
                        return (
                          <div className="row p-4  pt-2 ps-4 pb-2 ">
                            <hr className="hrproducts" />
                            <div className="col-4 ps-2 ">
                              <h3 className="licenseheader">Pricing details</h3>
                            </div>
                            <div className="col-6 pt-0">
                              <div className="col-12">
                                <div className="d-flex align-items-start">
                                  <FormLabel className="formlabel-style1">
                                    Billing account{" "}
                                  </FormLabel>
                                  <span className={`formlabel-input`}>
                                    &nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;
                                    {e.pricingDetails.billingAccount}
                                  </span>
                                </div>
                              </div>
                              <div className="col-12 mt-2">
                                <div className="d-flex align-items-start">
                                  <FormLabel className="formlabel-style1">
                                    Register number{" "}
                                  </FormLabel>
                                  <span className={`formlabel-input`}>
                                    &nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;
                                  </span>
                                </div>
                              </div>
                              <div className="col-12 mt-2">
                                <div className="d-flex align-items-start">
                                  <FormLabel className="formlabel-style1">
                                    Bill to{" "}
                                  </FormLabel>
                                  <span className={`formlabel-input`}>
                                    &nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;
                                    {e.pricingDetails.billToName}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-2">
                              <span className="isedit cursor-pointer float-end ">
                                <CommonIcon fileName={"editicon"} />
                              </span>
                            </div>
                          </div>
                        );
                      }
                    }
                  })}
                  {this.state.productsDetails.map((e) => {
                    if (this.state.buystart) {
                      if (e.summary != null) {
                        return (
                          <div className="row p-4 ps-1 pb-0 ps-4 pt-0">
                            <hr className="hrproducts" />
                            <div className="col-4">
                              <h3 className="licenseheader">Summary</h3>
                            </div>
                            <div className="col-6 pt-0">
                              <div className="col-12">
                                <div className="d-flex col-12 align-items-start">
                                  <FormLabel className="formlabel-style1 col-10">
                                    Monthly plan, paid monthly after trail
                                    (before tax):{" "}
                                  </FormLabel>
                                  <span className={`formlabel-input col-2`}>
                                    &#8377;{e.summary.monthlyAmount}
                                  </span>
                                </div>
                              </div>
                              <div className="col-12 mt-2">
                                <div className="d-flex align-items-start">
                                  <FormLabel className="formlabel-style1 col-10">
                                    Estimated taxes:{" "}
                                  </FormLabel>
                                  <span className={`formlabel-input col-2`}>
                                    &#8377;{e.summary.tax}
                                  </span>
                                </div>
                              </div>
                              <div className="col-12 mt-2">
                                <div className="d-flex align-items-start">
                                  <FormLabel className="formlabel-style1 col-10">
                                    Total paid monthly after trail (Annual
                                    plan):
                                  </FormLabel>
                                  <span className={`formlabel-input col-2`}>
                                    &#8377;{e.summary.totalPaid}
                                  </span>
                                </div>
                              </div>
                              <div className="col-12 mt-2">
                                <div className="d-flex align-items-start">
                                  <FormLabel className="formlabel-style1 col-10">
                                    Total today:
                                  </FormLabel>
                                  <span className={`formlabel-input col-2`}>
                                    &#8377;{e.summary.totalToday.toFixed(2)}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    }
                  })}
                </div>
                <div className="row p-4 ps-1 pt-0 ps-4 pb-0 ">
                  <div className="col-4"></div>
                  <div className="col-6">
                    {this.state.buystart && (
                      <button
                        className="btn-fun ps-3 p-2 pe-3 fs-7 mt-3"
                        onClick={this.subscribePrroduct}
                      >
                        Subscribe
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* Buy View */}
              <div
                className="offcanvas offcanvas-end"
                data-bs-scroll="false"
                data-bs-backdrop
                id="buyscreen"
                aria-labelledby="offcanvasScrollingLabel"
                style={{
                  width: this.props.menuToggle
                    ? "calc(100% - 240px)"
                    : "calc(100% - 70px)",
                  overflowX: "hidden",
                  height: "100vh",
                }}
              >
                <div className={`offcanvas-header  px-4`}>
                  <h3 className="applicationnametrial">
                    {this.state.applicationname}
                  </h3>

                  <button
                    data-bs-dismiss="offcanvas"
                    className="offcavasclose"
                    onClick={() => this.closeFormlic()}
                  >
                    <CommonIcon fileName={"Close"} />
                  </button>
                </div>
                <div className="row p-4 ps-1 pt-2 ps-4 pb-0 ">
                  <div className="col-4">
                    <h3 className="licenseheader">Select plan details</h3>
                  </div>
                  <div className="col-6">
                    <div className="col-12">
                      <FormLabel className="formlabel-style2 ">
                        Select a plan
                      </FormLabel>
                      <br />
                      <div className="d-flex align-items-start">
                        <input
                          type="radio"
                          value={this.state.applicationname}
                          className="radioinputtrial"
                          checked
                          name="planbuy"
                        />
                        <label className="radiolabel">
                          {this.state.applicationname}
                        </label>
                      </div>
                      <div className="d-flex align-items-start mt-1">
                        {" "}
                        <input
                          type="radio"
                          value={this.state.applicationname + "- Trail "}
                          name="planbuy"
                        />
                        <label className="radiolabel">
                          {this.state.applicationname + "- Trail"}
                        </label>
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <div className="d-flex">
                        <FormLabel className="formlabel-style2">
                          License Quantity{" "}
                        </FormLabel>
                      </div>
                      <div
                        className={` flex-wrap  align-items-start`}
                        id="licenseinput"
                      >
                        <TextField
                          className="number-field-1 mb-2"
                          value={this.state.mockTotallicense}
                          onChange={this.handleChange}
                          InputProps={{
                            inputProps: { min: 0 },
                            endAdornment: (
                              <InputAdornment position="end">
                                <div className="adornment-container">
                                  <div
                                    onClick={this.handleIncrement}
                                    className="cursor-pointer "
                                  >
                                    <CommonIcon fileName={"ArrowUpIcon"} />
                                  </div>
                                  <div
                                    onClick={() => this.handleDecrement()}
                                    className="cursor-pointer "
                                  >
                                    <CommonIcon fileName={"ArrowDownIcon"} />
                                  </div>
                                </div>
                              </InputAdornment>
                            ),
                          }}
                        />

                        {this.state.invalidLicense ? (
                          <label className="isrequired invalidlabel">
                            All license are assigned to users.
                          </label>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="mt-2">
                        <FormLabel className="formlabel-style2">
                          Subscription period
                        </FormLabel>
                        <div className="d-flex align-items-start">
                          <input
                            type="radio"
                            value="1 Month"
                            className="radioinputtrial"
                            checked
                          />
                          <label className="radiolabel">1 Month</label>
                        </div>
                        <div className="d-flex align-items-start mt-1">
                          {" "}
                          <input type="radio" value="1 Year" />
                          <label className="radiolabel">1 Year</label>
                        </div>
                      </div>
                    </div>

                    <button
                      className="btn-fun ps-3 p-2 pe-3 fs-7 mt-3"
                      onClick={this.subscribePrroduct}
                    >
                      Subscribe
                    </button>
                  </div>
                </div>
                <hr className="hrproducts" />
                <div className="row p-4 ps-1 pt-2 ps-4 pb-0">
                  <div className="col-4">
                    <h3 className="licenseheader">Pricing details</h3>
                  </div>
                  <div className="col-6 pt-0">
                    <div className="col-12">
                      <div className="d-flex align-items-start">
                        <FormLabel className="formlabel-style1">
                          Billing account{" "}
                        </FormLabel>
                        <span className={`formlabel-input`}>
                          &nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;Lorem
                          technologies
                        </span>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="d-flex align-items-start">
                        <FormLabel className="formlabel-style1">
                          Register number{" "}
                        </FormLabel>
                        <span className={`formlabel-input`}>
                          &nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;Accv890o
                        </span>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="d-flex align-items-start">
                        <FormLabel className="formlabel-style1">
                          Bill to{" "}
                        </FormLabel>
                        <span className={`formlabel-input`}>
                          &nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;John Doe
                        </span>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="d-flex align-items-start">
                        <FormLabel className="formlabel-style1">
                          Tax ID{" "}
                        </FormLabel>
                        <span className={`formlabel-input`}>
                          &nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;237C3AA1323
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-2">
                    <span className="isedit cursor-pointer float-end ">
                      <CommonIcon fileName={"editicon"} />
                    </span>
                  </div>
                </div>
                <hr className="hrproducts" />
                <div className="row p-4 ps-1 pt-2 ps-4 ">
                  <div className="col-4">
                    <h3 className="licenseheader">Summary</h3>
                  </div>
                  <div className="col-6 pt-0">
                    <div className="col-12">
                      <div className="d-flex col-12 align-items-start">
                        <FormLabel className="formlabel-style1 col-10">
                          Monthly plan, paid monthly after trail (before tax):{" "}
                        </FormLabel>
                        <span className={`formlabel-input col-2`}>
                          &#8377;5,410.00
                        </span>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="d-flex align-items-start">
                        <FormLabel className="formlabel-style1 col-10">
                          Estimated taxes:{" "}
                        </FormLabel>
                        <span className={`formlabel-input col-2`}>
                          &#8377;0
                        </span>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="d-flex align-items-start">
                        <FormLabel className="formlabel-style1 col-10">
                          Total paid monthly after trail (Annual plan):
                        </FormLabel>
                        <span className={`formlabel-input col-2`}>
                          &#8377;0
                        </span>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="d-flex align-items-start">
                        <FormLabel className="formlabel-style1 col-10">
                          Total today:
                        </FormLabel>
                        <span className={`formlabel-input col-2`}>
                          &#8377;0
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* UNSUBSCRIBE OFFCANVAS */}

              <div
                className="offcanvas offcanvas-end"
                // tabIndex={}

                data-bs-scroll="false"
                data-bs-backdrop
                id="Licenseform"
                aria-labelledby="offcanvasScrollingLabel"
                style={{
                  width: "calc(" + maindiv + "px - 13%)",
                }}
              >
                <div className={`offcanvas-header px-4 pt-4 pb-3 mt-10 g-3`}>
                  <h3>Buy licenses</h3>

                  <button
                    data-bs-dismiss="offcanvas"
                    className="offcavasclose"
                    onClick={() => this.closeFormlic()}
                  >
                    <CommonIcon fileName={"Close"} />
                  </button>
                </div>
                <div className="row px-4">
                  <div className="col-12">
                    <div className="col-12">
                      <span className="licensesub">Current quantity</span>
                    </div>
                    <div className="col-12">
                      <label>Total Licenses</label>
                      <span>1</span>
                    </div>
                    <div className="col-12">
                      <label>Monthly cost</label>
                      <span>145.00 plus applicable tax</span>
                    </div>
                  </div>
                  <div className="col-12">
                    <div>
                      <span className="licensesub">Current quantity</span>
                    </div>
                    <div className="col-12">
                      <label>Total Licenses</label>
                      <span>1</span>
                    </div>
                    <div className="col-12">
                      <label>Monthly cost</label>
                      <span>145.00 plus applicable tax</span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="offcanvas offcanvas-end"
                data-bs-scroll="false"
                data-bs-backdrop
                id="removeLicense"
                aria-labelledby="offcanvasScrollingLabel"
                style={{
                  width: "calc(" + maindiv + "px - 13%)",
                }}
              >
                <div className={`offcanvas-header px-4 pt-4 pb-3 mt-10 g-3`}>
                  <h1>Remove license</h1>

                  <button
                    data-bs-dismiss="offcanvas"
                    className="offcavasclose"
                    onClick={() => this.closeFormlic()}
                  >
                    <CommonIcon fileName={"Close"} />
                  </button>
                </div>
              </div>
            </div>
            <div
              className={`modal modal-style ${opendialog ? "show" : ""}`}
              id="Additionform"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
              style={{ display: opendialog ? "block" : "none" }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content shadow-lg bg-white rounded">
                  <div className="modal-body text-center">
                    <span>{this.state.successText}</span>
                  </div>
                  <div className="modal-footer justify-content-center">
                    <Button
                      className="btn-no px-4"
                      variant="primary"
                      onClick={() => this.noAction()}
                    >
                      No
                    </Button>{" "}
                    <Button
                      className="btn-action px-4"
                      variant="primary"
                      onClick={() => this.yesAction()}
                    >
                      Yes
                    </Button>{" "}
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`modal modal-style ${
                this.state.opendialogun ? "show" : ""
              }`}
              id="unsubscribemodal"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
              style={{
                display: this.state.opendialogun ? "block" : "none",
                zIndex: "1070",
              }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content shadow-lg bg-white rounded">
                  <div className="modal-body text-center">
                    <span>Are you sure to unsubscribe this product</span>
                  </div>
                  <div className="modal-footer justify-content-center">
                    <Button
                      className="btn-no px-4"
                      variant="primary"
                      onClick={() => this.noUnsubscribeAction()}
                    >
                      No
                    </Button>{" "}
                    <Button
                      className="btn-action px-4"
                      variant="primary"
                      onClick={() => this.yesUnsubscribeAction()}
                    >
                      Yes
                    </Button>{" "}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {/* Add & Edit */}
        <div
          className="offcanvas offcanvas-end  pt-2"
          data-bs-scroll="false"
          data-bs-backdrop
          id="productsViewScreen"
          aria-labelledby="offcanvasScrollingLabel"
          style={{
            width: this.props.menuToggle
              ? "calc(100% - 240px)"
              : "calc(100% - 70px)",
            overflowX: "hidden",
            height: "100vh",
          }}
        >
          {isWebMobile || this.state.isMobile ? (
            <>
              <div
                className="d-flex align-items-start"
                style={{ height: "87vh" }}
              >
                <div className="ps-3 w-100">
                  <div className="p-3 ps-1 pt-0 pb-1">
                    <div>
                      <h3 className="head">{this.state.applicationname}</h3>
                    </div>
                    <button
                      data-bs-dismiss="offcanvas"
                      className="offcavasclose float-end exitbutton1"
                      onClick={() => this.closeForm()}
                    >
                      <CommonIcon fileName={"Close"} />
                    </button>
                  </div>
                  <div className="ps-2 d-flex justify-content-between">
                    <label className="pathlabel">
                      Products &gt;<span className="isblue">Details</span>
                    </label>
                  </div>

                  {(this.state.subcriptionStatus == "Subscribed" ||
                    this.state.subcriptionStatus == "Trial") && (
                    <div className="row ps-1 mt-2 pe-3">
                      <div className="row p-4 ps-3 pe-0 pt-2 ">
                        <div className="col-12 d-flex justify-content-between pe-1">
                          <h3 className="licenseheader">License details</h3>
                          {this.state.subcriptionStatus != "Trial" && (
                            <div>
                              <span
                                className="editlicense cursor-pointer"
                                onClick={() =>
                                  this.setState({
                                    editLicense: !this.state.editLicense,
                                  })
                                }
                              >
                                {this.state.editLicense ? (
                                  ""
                                ) : (
                                  <CommonIcon fileName={"editicon"} />
                                )}
                              </span>
                            </div>
                          )}
                        </div>

                        <div className="col-12">
                          <div className="col-12 d-flex align-items-start">
                            <div className="col-12 mt-2">
                              <FormLabel className="formlabel-style1">
                                Total license count{" "}
                              </FormLabel>
                              <FormLabel
                                className={`px-2 ${
                                  !this.state.editLicense ? "" : "d-none"
                                }`}
                              >
                                -
                              </FormLabel>
                              <FormLabel
                                className={`formlabel-input mt--9 ${
                                  !this.state.editLicense ? "" : "d-none"
                                }`}
                              >
                                {this.state.totalLicense}
                              </FormLabel>

                              <div
                                className={`${
                                  this.state.editLicense ? "d-flex" : "d-none"
                                } flex-wrap mt-1  align-items-start`}
                                id="licenseinput"
                              >
                                <TextField
                                  className="number-field-1 mb-2"
                                  value={this.state.mockTotallicense}
                                  onChange={this.handleChange}
                                  InputProps={{
                                    inputProps: { min: 0 },
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <div className="adornment-container">
                                          <div
                                            onClick={this.handleIncrement}
                                            className="cursor-pointer "
                                          >
                                            <CommonIcon
                                              fileName={"ArrowUpIcon"}
                                            />
                                          </div>
                                          <div
                                            onClick={() =>
                                              this.handleDecrement()
                                            }
                                            className="cursor-pointer "
                                          >
                                            <CommonIcon
                                              fileName={"ArrowDownIcon"}
                                            />
                                          </div>
                                        </div>
                                      </InputAdornment>
                                    ),
                                  }}
                                />

                                {this.state.invalidLicense ? (
                                  <label className="isrequired invalidlabel">
                                    All license are assigned to users.
                                  </label>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-12  mt-2">
                            <FormLabel className="formlabel-style1">
                              Available license count{" "}
                            </FormLabel>
                            <FormLabel className={`px-2`}>-</FormLabel>
                            <FormLabel className={`formlabel-input mt--9 `}>
                              {this.state.availableLicense}
                            </FormLabel>
                          </div>

                          {this.state.subscribestartdate ? (
                            <div className="col-12 mt-2 ">
                              <FormLabel className="formlabel-style1">
                                Purchased Date{" "}
                              </FormLabel>
                              <FormLabel className={`px-2`}>-</FormLabel>{" "}
                              <FormLabel className={`formlabel-input mt--9`}>
                                {this.formatDate(this.state.subscribestartdate)}
                              </FormLabel>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.trialstartDate &&
                          this.state.subcriptionStatus == "Trial" ? (
                            <div className="col-12 mt-2 ">
                              <FormLabel className="formlabel-style1">
                                Trial Started Date{" "}
                              </FormLabel>{" "}
                              <FormLabel
                                className={`formlabel-input mt--9 d-block`}
                              >
                                {this.formatDate(this.state.trialstartDate)}
                              </FormLabel>
                            </div>
                          ) : (
                            ""
                          )}
                          {/* {this.state.expiryDate ? <div className="col-12 mt-2 ">
                                                        <FormLabel className="formlabel-style1">Expiry Date </FormLabel> <FormLabel className={`formlabel-input mt--9 d-block`}>{this.formatDate(this.state.expiryDate)}</FormLabel>

                                                    </div> : ""} */}
                          {this.state.subcriptionStatus != "Trial" ? (
                            <div className="col-12 col-sm-12 col-lg-12  mt-3">
                              <span
                                className="unsubscribe cursor-pointer p-2"
                                onClick={this.unsubscribe}
                              >
                                Unsubscribe
                              </span>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.subcriptionStatus == "Trial" ? (
                            <div className="col-12 col-sm-12 col-lg-12  mt-3">
                              <span
                                className="btn-fun p-2 px-3 fs-7 mt-3 cursor-pointer disabled"
                                onClick={() =>
                                  this.subscribePrroduct(this.state.clientId)
                                }
                              >
                                Upgrade
                              </span>
                            </div>
                          ) : (
                            ""
                          )}

                          {this.state.editLicense ? (
                            <div className="mt-3">
                              <button
                                className="btn-cancel btn-filter-action border-none"
                                onClick={() => this.cancellicense()}
                              >
                                Cancel
                              </button>
                              <button
                                className="btn-fun ms-2 ps-3 p-2 pe-3 fs-7"
                                onClick={this.savelicense}
                              >
                                Update
                              </button>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      {/* {this.state.expiryDate?<div className="col-12 col-sm-6 mb-3 col-lg-4 mt-2">
                          <FormLabel className="formlabel-style1 w-100">Expiry Date</FormLabel>
                          <FormLabel className="formlabel-input w-100">{this.formatDate(this.state.expiryDate)}</FormLabel>
                        </div>:""} */}

                      <div className="col-12 col-sm-6 mb-3 mt-6"></div>
                    </div>
                  )}
                  {this.state.subcriptionStatus == "Not Subscribed" && (
                    <div className="row ps-3 mt-2 pe-3 w-100">
                      <div className="col-12 col-sm-2 col-lg-2 mb-3 mt-4">
                        <button
                          className="tryapplicationbtn"
                          onClick={this.trial}
                        >
                          Start trail
                        </button>
                      </div>
                      <div className="col-12 col-sm-2 mb-3 col-lg-2 mt-4">
                        <button className="Buybtn">Purchase</button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              <div
                className="d-flex align-items-start"
                style={{ height: "87vh" }}
              >
                <div className="leftpanelprod">
                  <label className="leftpanelheaderprod p-2">Products</label>
                  {/* <hr className="hrsubscription" /> */}
                  <ul className="leftpanelulprod">
                    {this.state.normalData.map((element) => {
                      if (
                        element.subcriptionStatus == "Subscribed" ||
                        element.subcriptionStatus == "Trial"
                      ) {
                        return (
                          <li
                            className={`cursor-pointer ${
                              this.state.applicationname == element.name
                                ? "leftpanelli d-flex align-items-start "
                                : "leftpanelli1 d-flex align-items-start"
                            }`}
                            onClick={() =>
                              this.handleEditId(
                                element.id,
                                element.clientId,
                                element.subcriptionStatus,
                                element.trialExpiryDate,
                                element.trialStartDate,
                                element.subscriptionStartDate
                              )
                            }
                          >
                            <CommonIcon fileName={"idcardicon1"} />
                            &nbsp;&nbsp;&nbsp;
                            <label className="display-inline cursor-pointer">
                              {element.name}
                            </label>
                          </li>
                        );
                      }
                    })}
                  </ul>
                </div>
                <div className="ps-3 w-100">
                  <div className="p-3 ps-1 pt-0 pb-1 d-flex justify-content-between mt-2">
                    <div>
                      <h3 className="head">{this.state.applicationname}</h3>
                    </div>
                    <button
                      data-bs-dismiss="offcanvas"
                      className="offcavasclose me-1"
                      onClick={() => this.closeForm()}
                    >
                      <CommonIcon fileName={"Close"} />
                    </button>
                  </div>

                  {(this.state.subcriptionStatus == "Subscribed" ||
                    this.state.subcriptionStatus == "Trial") && (
                    <div className="row ps-1 mt-2 pe-0">
                      <div className="row p-4 ps-3 pt-0 ">
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-4">
                          <h3 className="licenseheader">License details</h3>
                        </div>
                        <div className="col-xl-8 col-lg-7 col-md-6 col-sm-10">
                          <div className="col-12 ">
                            <div className="d-flex">
                              <FormLabel className="formlabel-style1">
                                Total license count{" "}
                                <span className="px-3">-</span>
                              </FormLabel>{" "}
                              <FormLabel
                                className={`formlabel-input ${
                                  !this.state.editLicense ? "d-block" : "d-none"
                                }`}
                              >
                                {this.state.totalLicense}
                              </FormLabel>
                            </div>
                            <div
                              className={`${
                                this.state.editLicense ? "d-flex" : "d-none"
                              } flex-wrap mt-1  align-items-start`}
                              id="licenseinput"
                            >
                              <TextField
                                className="number-field-1 mb-2"
                                value={this.state.mockTotallicense}
                                onChange={this.handleChange}
                                InputProps={{
                                  inputProps: { min: 0 },
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <div className="adornment-container">
                                        <div
                                          onClick={this.handleIncrement}
                                          className="cursor-pointer "
                                        >
                                          <CommonIcon
                                            fileName={"ArrowUpIcon"}
                                          />
                                        </div>
                                        <div
                                          onClick={() => this.handleDecrement()}
                                          className="cursor-pointer "
                                        >
                                          <CommonIcon
                                            fileName={"ArrowDownIcon"}
                                          />
                                        </div>
                                      </div>
                                    </InputAdornment>
                                  ),
                                }}
                              />

                              {this.state.invalidLicense ? (
                                <label className="isrequired invalidlabel">
                                  All license are assigned to users.
                                </label>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div className="col-12  mt-3">
                            <div className="d-flex">
                              <FormLabel className="formlabel-style1">
                                Available license count{" "}
                                <span className="px-3">-</span>
                              </FormLabel>{" "}
                              <FormLabel className={`formlabel-input `}>
                                {this.state.availableLicense}
                              </FormLabel>
                            </div>
                          </div>

                          {this.state.subscribestartdate ? (
                            <div className="col-12 mt-3 ">
                              <div className="d-flex">
                                <FormLabel className="formlabel-style1">
                                  Purchased Date <span className="px-3">-</span>
                                </FormLabel>{" "}
                                <FormLabel className={`formlabel-input `}>
                                  {this.formatDate(
                                    this.state.subscribestartdate
                                  )}
                                </FormLabel>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.trialstartDate &&
                          this.state.subcriptionStatus == "Trial" ? (
                            <div className="col-12 mt-3 ">
                              <div className="d-flex">
                                <FormLabel className="formlabel-style1">
                                  Trial Started Date &nbsp;&nbsp;&nbsp;-
                                  &nbsp;&nbsp;&nbsp;
                                </FormLabel>{" "}
                                <FormLabel className={`formlabel-input `}>
                                  {this.formatDate(this.state.trialstartDate)}
                                </FormLabel>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          <div className="col-12  mt-3">
                            <div className="d-flex">
                              <FormLabel className="formlabel-style1">
                                Subscription Status
                                <span className="px-3">-</span>
                              </FormLabel>{" "}
                              <FormLabel className={` reporttext1211`}>
                                {this.state.subscriptionStatus}
                              </FormLabel>
                            </div>
                          </div>
                          {/* {this.state.expiryDate ? <div className="col-12 mt-3 ">
                                                            <div className='d-flex'><FormLabel className="formlabel-style1">Expiry Date &nbsp;&nbsp;&nbsp;- &nbsp;&nbsp;&nbsp;</FormLabel> <span className={`formlabel-input mt--9 `}>{this.formatDate(this.state.expiryDate)}</span></div>

                                                        </div> : ""} */}
                          {/* {this.state.subcriptionStatus != "Trial" ? <div className="col-12 col-sm-12 col-lg-12  mt-3">
                                                            <span className="unsubscribe p-2 cursor-pointer mt-3" onClick={this.unsubscribe}>Unsubscribe</span>
                                                        </div> : ""} */}
                          {this.state.subcriptionStatus == "Trial" ? (
                            <div className="col-12 col-sm-12 col-lg-12  mt-3">
                              <span
                                className="btn-fun  p-2 px-3  fs-7 mt-3 cursor-pointer disabled"
                                onClick={() =>
                                  this.subscribePrroduct(this.state.clientId)
                                }
                              >
                                Upgrade
                              </span>
                            </div>
                          ) : (
                            ""
                          )}

                          {this.state.editLicense ? (
                            <div className="mt-3">
                              <button
                                className="btn-cancel btn-filter-action border-none"
                                onClick={() => this.cancellicense()}
                              >
                                Cancel
                              </button>
                              <button
                                className="btn-fun ms-2 ps-3 p-2 pe-3 fs-7"
                                onClick={this.savelicense}
                              >
                                Update
                              </button>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        {this.state.subcriptionStatus != "Trial" && (
                          <div className="col-2 pe-0">
                            <span
                              className="editlicense cursor-pointer"
                              onClick={() =>
                                this.setState({
                                  editLicense: !this.state.editLicense,
                                })
                              }
                            >
                              {this.state.editLicense ? (
                                ""
                              ) : (
                                <CommonIcon fileName={"editicon"} />
                              )}
                            </span>
                          </div>
                        )}
                      </div>

                      {/* {this.state.expiryDate?<div className="col-12 col-sm-6 mb-3 col-lg-4 mt-2">
                          <FormLabel className="formlabel-style1 w-100">Expiry Date</FormLabel>
                          <FormLabel className="formlabel-input w-100">{this.formatDate(this.state.expiryDate)}</FormLabel>
                        </div>:""} */}

                      <div className="col-12 col-sm-6 mb-3 mt-6"></div>
                    </div>
                  )}
                  {this.state.subcriptionStatus == "Not Subscribed" && (
                    <div className="row ps-3 mt-2 pe-3 w-100">
                      <div className="col-12 col-sm-2 col-lg-2 mb-3 mt-4">
                        <button
                          className="tryapplicationbtn"
                          onClick={this.trial}
                        >
                          Start trail
                        </button>
                      </div>
                      <div className="col-12 col-sm-2 mb-3 col-lg-2 mt-4">
                        <button className="Buybtn">Purchase</button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
        {/* Place Order */}
        <div
          className="offcanvas offcanvas-end"
          data-bs-scroll="false"
          data-bs-backdrop
          id="orderplacescreen"
          aria-labelledby="offcanvasScrollingLabel"
          style={{
            width: this.props.menuToggle
              ? "calc(100% - 240px)"
              : "calc(100% - 70px)",
            overflowX: "hidden",
            height: "100vh",
          }}
        >
          <div className={`offcanvas-header  px-4`}>
            <h3 className="applicationnametrial">Order placed</h3>

            <button
              data-bs-dismiss="offcanvas"
              className="offcavasclose"
              onClick={() => this.closeFormorderPlaced()}
            >
              <CommonIcon fileName={"Close"} />
            </button>
          </div>
          <div className="ps-4">
            <span className="managetext">
              Manage licenses and payments related to your new subscription{" "}
            </span>
            <br />
            <button
              className="btn-fun ps-3 p-2 pe-3 fs-7 mt-2"
              onClick={this.subscribeNavigate}
            >
              Manage new subscription
            </button>
          </div>
        </div>
        <div
          className="offcanvas offcanvas-end"
          data-bs-scroll="false"
          // data-bs-backdrop="false"
          id="newtrialscreen"
          aria-labelledby="offcanvasScrollingLabel"
          style={{
            width: this.props.menuToggle
              ? "calc(100% - 240px)"
              : "calc(100% - 70px)",
            overflowX: "hidden",
            height: "100vh",
          }}
        >
          <div className={`offcanvas-header  px-4`}>
            <h3 className="applicationnametrial">
              {this.state.applicationname}
            </h3>

            <button
              data-bs-dismiss="offcanvas"
              className="offcavasclose"
              onClick={() => this.closeFormlic()}
            >
              <CommonIcon fileName={"Close"} />
            </button>
          </div>
          <div className="row p-4 ps-1 pt-2 ps-4 pb-0">
            <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-6 col-sm-12 ">
              <h3 className="licenseheader">Trial Details</h3>
            </div>

            <div className="col-xxl-10 col-xl-10 col-lg-9 col-md-6 col-sm-12">
              <div className="col-12">
                {/* <FormLabel className="formlabel-style2 ">Select a plan</FormLabel><br />


                                            {this.state.productsDetails.map((e) => {
                                                return (<>
                                                    <div className="d-flex align-items-start"><input type="radio" value={e.planId} className="radioinputtrial" name="plan" checked={this.state.selectedPlanId === e.planId} onChange={(event) => this.onradioChange(event, e.planName)} /><label className="radiolabel">{e.planName}</label></div>
                                                </>)
                                            })} */}
                <div className="col-12 ">
                  <div className="d-flex">
                    <FormLabel className="formlabel-style2">
                      License Quantity{" "}
                    </FormLabel>
                    <FormLabel className="px-2">-</FormLabel>
                    <FormLabel className="formlabel-input">
                      {this.state.trialCount ?? 0}
                    </FormLabel>
                  </div>
                  {/* <div className={` flex-wrap  align-items-start`} id="licenseinput">
                                                    <TextField
                                                        className="number-field-1 mb-2"
                                                        value={this.state.mockTotallicense}
                                                        onChange={this.handleChange}
                                                        InputProps={{
                                                            inputProps: { min: 0 },
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <div className="adornment-container">
                                                                        <div onClick={this.handleIncrement} className="cursor-pointer ">
                                                                            <CommonIcon fileName={"ArrowUpIcon"} />
                                                                        </div>
                                                                        <div onClick={() => this.handleDecrement()} className="cursor-pointer ">
                                                                            <CommonIcon fileName={"ArrowDownIcon"} />
                                                                        </div>
                                                                    </div>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    /><br />

                                                    {this.state.invalidLicense ? <label className="isrequired invalidlabel">All license are assigned to users.</label> : ""}
                                                </div> */}
                  {/* {this.state.trailstart ?
                                                    <>
                                                        <FormLabel className="formlabel-style2">Subscription period</FormLabel><span className="subperiod">&nbsp;-&nbsp;&nbsp;&nbsp; 1 month</span>
                                                    </>
                                                    : ""} */}
                </div>
              </div>

              {this.state.trailstart && (
                <button
                  className="btn-fun ps-3 p-2 pe-3 fs-7 mt-2"
                  onClick={() => this.startTrial()}
                >
                  Start Trial
                </button>
              )}
            </div>
          </div>
        </div>
        {/* filter offcanvas */}
        <div
          className="offcanvas offcanvas-end"
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="FilterScreen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div className={`offcanvas-header px-4 pt-4 pb-3 mt-10`}>
            <h6
              id="offcanvasRightLabel"
              className="modal-title head-span"
              style={{ fontWeight: "600" }}
            >
              Filter
            </h6>
            <button
              className="offcavasclose"
              onClick={() => this.closeWebFilter1()}
            >
              <CommonIcon fileName={"Close"} />
            </button>
          </div>

          <div className="offcanvas-body px-4 pt-0">
            <div className="row">
              <div
                className="row"
                style={{
                  padding: "1rem",
                  paddingTop: "0",
                  paddingRight: "0px",
                }}
              >
                <div className={`col-12 mt-2 pe-2`}>
                  {/* <TextField
                                                    id="jobOpTitle"
                                                    className="filter_input"
                                                    fullWidth
                                                    label="Application"
                                                    variant="filled"
                                                    value={this.state.choice.application}
                                                    onChange={(e) =>
                                                        this.lookupChange(e, "", "application")
                                                    }
                                                    focused
                                                /> */}
                  <Autocomplete
                    multiple
                    id="roleId"
                    className="Multiprod"
                    disablePortal
                    variant="filled"
                    options={this.state.filterProductDropdown}
                    isOptionEqualToValue={(option, value) =>
                      option.applicationId === value.applicationId
                    }
                    getOptionLabel={(option) => option.name || ""}
                    value={this.state.choice?.application || []}
                    onChange={(e, selectedValues) => {
                      const mapped = selectedValues.map((item) => ({
                        clientId: item.clientId,
                        applicationId: item.applicationId,
                        name: item.name,
                        colorCode: item.colorCode,
                      }));
                      this.lookupChange(e, mapped, "application");
                    }}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                        {option.name}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="filled"
                        className="filter_input Multiprod"
                        focused
                        label="Applications"
                        InputLabelProps={{
                          shrink: true, // force label to float up always
                        }}
                        sx={{
                          "& .MuiInputBase-root": {
                            paddingTop: "30px", // space for label
                            alignItems: "flex-start",
                            flexWrap: "wrap",
                            minHeight: "64px",
                          },
                          "& .MuiInputLabel-root": {
                            top: "10px", // adjust label position if needed
                          },
                          "& .MuiChip-root": {
                            margin: "2px",
                          },
                        }}
                      />
                    )}
                  />
                </div>
                <div className={`col-12 mt-2 pe-2`}>
                  <Autocomplete
                    focused
                    id="roleId"
                    variant="filled"
                    disablePortal
                    value={
                      this.state.choice.subscriptionStatus
                        ? { status: this.state.choice.subscriptionStatus }
                        : null
                    }
                    options={[
                      { id: "1", status: "Subscribed" },
                      { id: "2", status: "Not subscribed" },
                      { id: "3", status: "Trial" },
                    ]}
                    getOptionLabel={(option) => option.status || ""}
                    onChange={(e, selectedValue) =>
                      this.lookupChange(e, selectedValue, "subscriptionStatus")
                    }
                    renderOption={(props, option, { selected }) => (
                      <li {...props} key={option.id}>
                        {option.status}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="filled"
                        className="filter_input"
                        focused
                        label="Subscription Status"
                      />
                    )}
                  />
                </div>
                <div className={`col-12 mt-2 pe-2`}>
                  {/* <TextField
                    type="date"
                    id="jobOpOpenPositions"
                    fullWidth
                    label="Purchased Date"
                    className="filter_input"
                    variant="filled"
                    value={this.state.choice.purchasedDate || ""}
                    onChange={(e) => this.lookupChange(e, "", "purchasedDate")}
                    focused
                    disablePortal
                  /> */}
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      id="jobOpOpenPositions"
                      format="DD MMM YYYY"
                      className="filter_input"
                      maxDate={dayjs()}
                      value={this.state.choice.purchasedDate || null}
                      variant="filled"
                      focused
                      enableAccessibleFieldDOMStructure={false}
                      onChange={(date) =>
                        this.lookupChange(
                          { target: { value: date } },
                          "",
                          "purchasedDate"
                        )
                      }
                      slots={{
                        textField: TextField,
                      }}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          focused: true,
                          label: "Purchased Date",
                          onKeyDown: (e) => e.preventDefault(),
                          onFocus: (e) => e.target.blur(),
                          onMouseDown: (e) => e.preventDefault(),
                          variant: "filled", // 👈 SAME LOOK AS YOUR OLD TEXTFIELD
                          placeholder: "DD MMM YYYY",
                          className: "filter_input",
                          id: "jobOpOpenPositions", // 👈 YOUR CUSTOM CLASS
                          InputLabelProps: { shrink: true }, // 👈 Ensures floating label works
                          sx: {
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#F5F5F5", // Optional: match your theme
                              borderRadius: "4px",
                            },
                          },
                        },
                        popper: { disablePortal: true },
                        inputAdornment: {
                          position: "start",
                        },
                      }}
                    />
                  </LocalizationProvider>
                </div>
              </div>
            </div>
          </div>
          <div className="row pe-4">
            <div className="col-12 align_justify_end pb-20 ">
              <Button
                className="btn-clear mr-10 border-none"
                variant="outlined"
                onClick={() => this.clearFilter()}
                sx={{
                  borderRadius: 0,
                  "&:hover": {
                    borderRadius: 0,
                  },
                }}
              >
                Reset
              </Button>
              <button
                className="btn-apply"
                variant="primary"
                onClick={() => this.applyFilter()}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleMenu: () => dispatch(toggleMenu()) || false,
    // sideMenu: () => dispatch(sideMenu()) || false,
    dispatch,
  };
};
function mapStateToProps(state) {
  return {
    getapplication: state.applicationReducer.getapplication,
    getApplicationLicenseStatus:
      state.applicationReducer.getApplicationLicenseStatus,
    getApplicationUsers: state.applicationReducer.getApplicationUsers,
    auditLog: state.applicationReducer.auditLog,
    userRoleAssign: state.applicationReducer.userRoleAssign,
    menuToggle: state.SideBarReducer.menuToggle,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Application)
);
